var _filter, _filter2, _filter3, _filter4, _filter5, _filter6, _filter7, _filter8, _filter9, _filter10, _filter11, _filter12, _filter13, _filter14, _filter15, _filter16, _filter17, _path, _g, _path2, _g2, _path3, _g3, _g4, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _g5, _path59, _g6, _path60, _path61, _path62, _g7, _g8, _path63, _g9, _ellipse, _ellipse2, _ellipse3, _path64, _ellipse4, _ellipse5, _ellipse6, _path65, _ellipse7, _ellipse8, _ellipse9, _path66, _ellipse10, _ellipse11, _ellipse12, _path67, _ellipse13, _ellipse14, _ellipse15, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _g10, _ellipse16, _ellipse17, _ellipse18, _path122, _ellipse19, _ellipse20, _ellipse21, _path123, _ellipse22, _ellipse23, _ellipse24, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "837px",
    height: "728px",
    viewBox: "552.5 -72.5 837 728",
    enableBackground: "new 552.5 -72.5 837 728",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    height: "415.6%",
    width: "510%",
    id: "i",
    filterUnits: "objectBoundingBox",
    y: "-155.9%",
    x: "-198.3%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    result: "shadowOffsetOuter1",
    in: "SourceAlpha",
    dy: 0,
    dx: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "shadowBlurOuter1",
    in: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 1 0 0 0 0 0.918817935 0 0 0 1 0",
    result: "shadowMatrixOuter1",
    in: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    height: "435.7%",
    width: "510%",
    id: "h",
    filterUnits: "objectBoundingBox",
    y: "-167.8%",
    x: "-198.3%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    result: "shadowOffsetOuter1",
    in: "SourceAlpha",
    dy: 0,
    dx: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "shadowBlurOuter1",
    in: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 1 0 0 0 0 0.918817935 0 0 0 1 0",
    result: "shadowMatrixOuter1",
    in: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    height: "435.7%",
    width: "510%",
    id: "f",
    filterUnits: "objectBoundingBox",
    y: "-167.8%",
    x: "-198.3%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    result: "shadowOffsetOuter1",
    in: "SourceAlpha",
    dy: 0,
    dx: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "shadowBlurOuter1",
    in: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 1 0 0 0 0 0.918817935 0 0 0 1 0",
    result: "shadowMatrixOuter1",
    in: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _filter4 || (_filter4 = /*#__PURE__*/React.createElement("filter", {
    height: "415.6%",
    width: "510%",
    id: "d",
    filterUnits: "objectBoundingBox",
    y: "-155.9%",
    x: "-198.3%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    result: "shadowOffsetOuter1",
    in: "SourceAlpha",
    dy: 0,
    dx: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "shadowBlurOuter1",
    in: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 1 0 0 0 0 0.918817935 0 0 0 1 0",
    result: "shadowMatrixOuter1",
    in: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _filter5 || (_filter5 = /*#__PURE__*/React.createElement("filter", {
    height: "302.3%",
    width: "346.3%",
    id: "ax",
    filterUnits: "objectBoundingBox",
    y: "-99.2%",
    x: "-121.2%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    result: "shadowOffsetOuter1",
    in: "SourceAlpha",
    dy: 0,
    dx: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "shadowBlurOuter1",
    in: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 1 0 0 0 0 0.918817935 0 0 0 1 0",
    result: "shadowMatrixOuter1",
    in: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _filter6 || (_filter6 = /*#__PURE__*/React.createElement("filter", {
    height: "302.3%",
    width: "346.3%",
    id: "aw",
    filterUnits: "objectBoundingBox",
    y: "-99.2%",
    x: "-121.2%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    result: "shadowOffsetOuter1",
    in: "SourceAlpha",
    dy: 0,
    dx: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "shadowBlurOuter1",
    in: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 1 0 0 0 0 0.918817935 0 0 0 1 0",
    result: "shadowMatrixOuter1",
    in: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _filter7 || (_filter7 = /*#__PURE__*/React.createElement("filter", {
    height: "302.3%",
    width: "346.3%",
    id: "av",
    filterUnits: "objectBoundingBox",
    y: "-99.2%",
    x: "-121.2%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    result: "shadowOffsetOuter1",
    in: "SourceAlpha",
    dy: 0,
    dx: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "shadowBlurOuter1",
    in: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 1 0 0 0 0 0.918817935 0 0 0 1 0",
    result: "shadowMatrixOuter1",
    in: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _filter8 || (_filter8 = /*#__PURE__*/React.createElement("filter", {
    height: "302.3%",
    width: "346.3%",
    id: "au",
    filterUnits: "objectBoundingBox",
    y: "-99.2%",
    x: "-121.2%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    result: "shadowOffsetOuter1",
    in: "SourceAlpha",
    dy: 0,
    dx: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "shadowBlurOuter1",
    in: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 1 0 0 0 0 0.918817935 0 0 0 1 0",
    result: "shadowMatrixOuter1",
    in: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _filter9 || (_filter9 = /*#__PURE__*/React.createElement("filter", {
    height: "302.3%",
    width: "346.3%",
    id: "at",
    filterUnits: "objectBoundingBox",
    y: "-99.2%",
    x: "-121.2%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    result: "shadowOffsetOuter1",
    in: "SourceAlpha",
    dy: 0,
    dx: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "shadowBlurOuter1",
    in: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 1 0 0 0 0 0.918817935 0 0 0 1 0",
    result: "shadowMatrixOuter1",
    in: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _filter10 || (_filter10 = /*#__PURE__*/React.createElement("filter", {
    height: "302.3%",
    width: "346.3%",
    id: "ap",
    filterUnits: "objectBoundingBox",
    y: "-99.2%",
    x: "-121.2%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    result: "shadowOffsetOuter1",
    in: "SourceAlpha",
    dy: 0,
    dx: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "shadowBlurOuter1",
    in: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 1 0 0 0 0 0.918817935 0 0 0 1 0",
    result: "shadowMatrixOuter1",
    in: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _filter11 || (_filter11 = /*#__PURE__*/React.createElement("filter", {
    height: "435.7%",
    width: "510%",
    id: "P",
    filterUnits: "objectBoundingBox",
    y: "-167.8%",
    x: "-198.3%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    result: "shadowOffsetOuter1",
    in: "SourceAlpha",
    dy: 0,
    dx: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "shadowBlurOuter1",
    in: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 1 0 0 0 0 0.918817935 0 0 0 1 0",
    result: "shadowMatrixOuter1",
    in: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _filter12 || (_filter12 = /*#__PURE__*/React.createElement("filter", {
    height: "415.6%",
    width: "510%",
    id: "O",
    filterUnits: "objectBoundingBox",
    y: "-155.9%",
    x: "-198.3%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    result: "shadowOffsetOuter1",
    in: "SourceAlpha",
    dy: 0,
    dx: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "shadowBlurOuter1",
    in: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 1 0 0 0 0 0.918817935 0 0 0 1 0",
    result: "shadowMatrixOuter1",
    in: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _filter13 || (_filter13 = /*#__PURE__*/React.createElement("filter", {
    height: "415.6%",
    width: "510%",
    id: "N",
    filterUnits: "objectBoundingBox",
    y: "-155.9%",
    x: "-198.3%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    result: "shadowOffsetOuter1",
    in: "SourceAlpha",
    dy: 0,
    dx: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "shadowBlurOuter1",
    in: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 1 0 0 0 0 0.918817935 0 0 0 1 0",
    result: "shadowMatrixOuter1",
    in: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _filter14 || (_filter14 = /*#__PURE__*/React.createElement("filter", {
    height: "435.7%",
    width: "510%",
    id: "J",
    filterUnits: "objectBoundingBox",
    y: "-167.8%",
    x: "-198.3%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    result: "shadowOffsetOuter1",
    in: "SourceAlpha",
    dy: 0,
    dx: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "shadowBlurOuter1",
    in: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 1 0 0 0 0 0.918817935 0 0 0 1 0",
    result: "shadowMatrixOuter1",
    in: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _filter15 || (_filter15 = /*#__PURE__*/React.createElement("filter", {
    height: "435.7%",
    width: "510%",
    id: "I",
    filterUnits: "objectBoundingBox",
    y: "-167.8%",
    x: "-198.3%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    result: "shadowOffsetOuter1",
    in: "SourceAlpha",
    dy: 0,
    dx: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "shadowBlurOuter1",
    in: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 1 0 0 0 0 0.918817935 0 0 0 1 0",
    result: "shadowMatrixOuter1",
    in: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _filter16 || (_filter16 = /*#__PURE__*/React.createElement("filter", {
    height: "415.6%",
    width: "510%",
    id: "G",
    filterUnits: "objectBoundingBox",
    y: "-155.9%",
    x: "-198.3%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    result: "shadowOffsetOuter1",
    in: "SourceAlpha",
    dy: 0,
    dx: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "shadowBlurOuter1",
    in: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 1 0 0 0 0 0.918817935 0 0 0 1 0",
    result: "shadowMatrixOuter1",
    in: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _filter17 || (_filter17 = /*#__PURE__*/React.createElement("filter", {
    height: "415.6%",
    width: "510%",
    id: "C",
    filterUnits: "objectBoundingBox",
    y: "-155.9%",
    x: "-198.3%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    result: "shadowOffsetOuter1",
    in: "SourceAlpha",
    dy: 0,
    dx: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "shadowBlurOuter1",
    in: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 1 0 0 0 0 0.918817935 0 0 0 1 0",
    result: "shadowMatrixOuter1",
    in: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "wordpresshosting") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 393.147,
    y1: 670,
    x2: 393.5912,
    y2: 669.9067,
    gradientTransform: "matrix(209.323 0 0 -71.7352 -81259.5469 48191.7891)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#02E8FD",
      stopOpacity: 0.427
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#01CCFB",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 393.4736,
    y1: 669.3701,
    x2: 392.0598,
    y2: 669.3677,
    gradientTransform: "matrix(209.323 0 0 -71.7352 -81259.5469 48191.7891)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#01E4FC",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    style: {
      stopColor: "#02EBFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#01E2FB",
      stopOpacity: 0
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    stroke: "url(#SVGID_2_)",
    strokeWidth: 1.444,
    d: "M1154.903,168.05L1001.01,79.128 c-17.261-9.974-38.524-10.009-55.817-0.093l-123.535,70.848l10.216,17.812l123.54-70.847c10.943-6.275,24.399-6.253,35.323,0.058 l153.893,88.921L1154.903,168.05z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1018.728 146.083)",
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00F6FF",
    d: "M-42.057-58.754l-3.994-2.309l3.994-2.303l3.993,2.305L-42.057-58.754z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#03E2F9",
    d: "M-38.064-61.062l-3.993-2.305v-4.612l3.993,2.305V-61.062z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#69E0FF",
    d: "M-42.057-63.366l-3.994,2.305v-4.612l3.994-2.305V-63.366z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 377.1338,
    y1: 667.0049,
    x2: 375.7954,
    y2: 667.5229,
    gradientTransform: "matrix(25.059 0 0 -17.035 -8522.8379 11475.8613)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00F6FF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#02CDE7"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M932.497,98.16v4.612l-35.9,20.203v-4.611l-3.995-2.307l35.901-20.201L932.497,98.16z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(968.215 168.41)",
    filter: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00F6FF",
    d: "M-67.624-47.74l-3.994,2.306v-4.612l3.994-2.306V-47.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#03E2F9",
    d: "M-71.618-45.434l-3.995-2.306v-4.612l3.995,2.306V-45.434z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#69E0FF",
    d: "M-71.618-50.046l-3.995-2.306l3.995-2.307l3.994,2.307L-71.618-50.046z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 379.1509,
    y1: 666.7529,
    x2: 377.8131,
    y2: 667.3137,
    gradientTransform: "matrix(24.775 0 0 -17.527 -8317.4092 11815.9902)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00F6FF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#02CDE7"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_4_)",
    d: "M1080.724,136.987l-3.994,2.305l-35.447-20.985l3.994-2.306v-4.612l35.447,20.986V136.987z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1061.775 167.064)",
    filter: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00F6FF",
    d: "M-16.499-46.452l-3.994-2.306l3.994-2.306l3.994,2.306L-16.499-46.452z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#03E2F9",
    d: "M-20.493-48.758v-4.61l3.994-2.307v4.612L-20.493-48.758z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#69E0FF",
    d: "M-16.604-50.941v-4.734l4.1,2.367v4.733L-16.604-50.941z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1095.016 186.144)",
    filter: "url(#i)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00F6FF",
    d: "M3.107-35.038l-3.996-2.309l3.996-2.303L7.1-37.345L3.107-35.038z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#03E2F9",
    d: "M7.1-37.345l-3.993-2.305v-4.612L7.1-41.956V-37.345z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#69E0FF",
    d: "M3.107-39.649l-3.996,2.305v-4.612l3.996-2.305V-39.649z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#01E5FB",
    d: "M829.051,185.865l-1.146-1.99l136.726-78.671c6.048-3.479,13.492-3.471,19.532,0.024l150.779,87.233 l-1.153,1.99l-150.78-87.235c-5.328-3.083-11.895-3.09-17.232-0.021L829.051,185.865z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#01E5FB",
    d: "M827.782,202.354l-1.146-1.99l142.475-81.979c2.489-1.433,5.555-1.429,8.041,0.009l156.521,90.555 l-1.152,1.99l-156.52-90.555c-1.777-1.027-3.966-1.029-5.744-0.006L827.782,202.354L827.782,202.354z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#0D054C",
    enableBackground: "new    ",
    d: "M778.778,88.895L976.79,206.529 c1.993,1.167,2.823,4.065,1.856,6.472c-0.394,0.977-1.046,1.767-1.856,2.241L780.482,330.303c-5.162,3.023-11.187,3.023-16.35,0 L563.566,214.112c-1.993-1.167-2.825-4.064-1.856-6.472c0.392-0.977,1.046-1.767,1.856-2.241L762.429,88.895 C767.591,85.869,773.616,85.869,778.778,88.895z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#01E1FA",
    d: "M763.934,108.308L596.24,206.551c-0.569,0.334-1.039,0.9-1.321,1.61c-0.717,1.776-0.103,3.913,1.32,4.747 l169.131,97.979c4.175,2.445,9.033,2.445,13.206,0l165.539-97.025c0.568-0.334,1.037-0.899,1.324-1.608 c0.714-1.776,0.1-3.915-1.326-4.75l-166.976-99.197c-4.171-2.445-9.031-2.443-13.205,0L763.934,108.308z M777.72,107.316 l166.979,99.199c1.937,1.136,2.726,3.884,1.808,6.167c-0.379,0.94-1.012,1.704-1.808,2.172l-165.539,97.025 c-4.532,2.656-9.837,2.656-14.365,0L595.657,213.9c-1.937-1.135-2.726-3.885-1.808-6.167c0.376-0.939,1.012-1.705,1.808-2.171 l167.693-98.244c4.532-2.659,9.837-2.659,14.367,0L777.72,107.316z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 392.8613,
    y1: 669.8574,
    x2: 391.4835,
    y2: 670.3094,
    gradientTransform: "matrix(184.8823 0 0 -108.85 -71742.3125 73146.6563)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00C2FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B78FF"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_5_)",
    d: "M776.536,124.551l139.517,82.884c1.403,0.823,1.99,2.866,1.308,4.559 c-0.251,0.657-0.711,1.212-1.308,1.58l-138.314,81.069c-3.638,2.133-7.884,2.133-11.521,0l-141.316-81.865 c-1.404-0.823-1.99-2.865-1.308-4.559c0.25-0.656,0.709-1.212,1.308-1.58l140.114-82.088 C768.654,122.418,772.9,122.418,776.536,124.551z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 391.1309,
    y1: 669.7988,
    x2: 392.4098,
    y2: 669.7667,
    gradientTransform: "matrix(158.0602 0 0 -85.0655 -61146.8711 57190.9258)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A22BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6607,
    style: {
      stopColor: "#0B0D7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A22BE"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_6_)",
    d: "M796.705,148.279l100.523,12.683v47.369c0.146,0.661,0.104,1.385-0.162,2.047 c-0.239,0.596-0.638,1.076-1.13,1.364L776.47,281.765c-3.143,1.843-6.81,1.843-9.95,0l-119.467-70.021 c-0.756-0.442-1.236-1.29-1.352-2.221h-0.024v-48.56h100.608l20.235-11.861c3.141-1.841,6.809-1.841,9.95,0L796.705,148.279z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B0F89",
    d: "M669.078,190.921c1.026,0.501,1.678,1.545,1.68,2.688v16.939c0,0.551-0.446,0.999-0.997,0.999 c-0.152,0-0.303-0.034-0.44-0.101l-3.118-1.523c-1.027-0.502-1.679-1.546-1.679-2.69v-16.939c0-0.551,0.447-0.998,0.999-0.997 c0.151,0,0.3,0.035,0.437,0.101L669.078,190.921z M659.436,185.61c1.029,0.502,1.681,1.546,1.681,2.69v16.939 c-0.001,0.551-0.447,0.998-0.999,0.998c-0.151,0-0.301-0.035-0.438-0.101l-3.118-1.524c-1.028-0.502-1.681-1.546-1.68-2.69v-16.939 c0-0.551,0.448-0.999,0.998-0.998c0.152,0,0.302,0.035,0.438,0.101L659.436,185.61z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 389.8896,
    y1: 669.5537,
    x2: 388.132,
    y2: 669.8684,
    gradientTransform: "matrix(82.1547 0 0 -85.0655 -31126.6543 57190.4883)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F0856"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B0F89"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_7_)",
    d: "M796.116,160.233h100.524v47.369c0.145,0.661,0.104,1.385-0.163,2.048 c-0.239,0.595-0.638,1.076-1.131,1.364l-119.465,70.021c-3.144,1.843-6.812,1.843-9.95,0V148.373c3.139-1.841,6.807-1.841,9.95,0 L796.116,160.233z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B0F89",
    d: "M826.952,215.691l48.967-28.804c0.453-0.267,0.999-0.042,1.22,0.503c0.062,0.153,0.095,0.316,0.095,0.482 v4.481c0,1.258-0.598,2.408-1.538,2.962l-48.967,28.802c-0.452,0.266-0.998,0.042-1.219-0.504 c-0.063-0.153-0.094-0.316-0.092-0.481v-4.483C825.418,217.392,826.012,216.244,826.952,215.691z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 380.7598,
    y1: 666.4092,
    x2: 379.3803,
    y2: 667.0913,
    gradientTransform: "matrix(32.547 0 0 -23.5268 -11517.543 15893.2441)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00C2FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B78FF"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_8_)",
    d: "M829.379,217.29l48.966-28.804c0.454-0.266,1-0.042,1.222,0.505c0.061,0.153,0.092,0.316,0.092,0.48 v4.484c0,1.257-0.596,2.405-1.534,2.958l-48.969,28.804c-0.452,0.268-0.998,0.042-1.219-0.503 c-0.063-0.153-0.094-0.317-0.094-0.482v-4.481c0-1.257,0.596-2.407,1.535-2.961L829.379,217.29z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 380.7578,
    y1: 665.6152,
    x2: 379.378,
    y2: 666.1252,
    gradientTransform: "matrix(32.547 0 0 -20.34 -11517.543 13762.0674)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00C2FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B78FF"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_9_)",
    d: "M829.379,231.241l48.966-28.805c0.454-0.266,1-0.04,1.222,0.505 c0.061,0.153,0.092,0.317,0.092,0.482v-0.592c0,1.257-0.596,2.407-1.534,2.96l-48.969,28.804c-0.452,0.266-0.998,0.04-1.219-0.504 c-0.063-0.153-0.094-0.316-0.094-0.481v0.591C827.843,232.942,828.438,231.793,829.379,231.241L829.379,231.241z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B0F89",
    d: "M776.47,88.687l119.467,70.021c1.212,0.71,1.719,2.474,1.13,3.939c-0.239,0.596-0.638,1.076-1.13,1.364 L776.47,234.033c-3.143,1.841-6.81,1.841-9.95,0l-119.467-70.022c-1.214-0.71-1.72-2.474-1.13-3.939 c0.237-0.595,0.636-1.076,1.13-1.364L766.52,88.687C769.66,86.844,773.327,86.844,776.47,88.687z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 392.5537,
    y1: 670.2344,
    x2: 390.3242,
    y2: 669.871,
    gradientTransform: "matrix(153.5756 0 0 -90.4187 -59375.5781 60747.6875)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#188EFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1B37D6"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_10_)",
    d: "M776.375,88.62l115.891,68.848c1.166,0.685,1.652,2.38,1.087,3.79 c-0.209,0.544-0.59,1.005-1.087,1.31L777.373,229.91c-3.021,1.77-6.547,1.77-9.568,0l-117.389-68.005 c-1.166-0.684-1.653-2.38-1.087-3.789c0.229-0.571,0.612-1.035,1.087-1.312l116.39-68.186c3.019-1.772,6.548-1.772,9.567,0 L776.375,88.62z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00BDFA",
    strokeWidth: 0.722,
    d: "M774.787,109.496c-2.085-1.221-4.505-1.221-6.587,0l-86.075,50.449 c-0.261,0.165-0.461,0.412-0.57,0.701c-0.322,0.802-0.045,1.768,0.572,2.128l86.073,50.45c2.083,1.22,4.504,1.22,6.587,0 l86.075-50.45c0.261-0.164,0.463-0.411,0.57-0.701c0.322-0.802,0.045-1.767-0.572-2.128L774.787,109.496z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 389.9492,
    y1: 669.4199,
    x2: 388.5629,
    y2: 669.3506,
    gradientTransform: "matrix(88.1718 0 0 -51.6361 -33541.0352 34726.1836)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A22BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B0F89"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_11_)",
    d: "M774.268,121.59l66.643,38.864c0.678,0.395,0.961,1.375,0.633,2.186 c-0.121,0.315-0.344,0.582-0.631,0.758l-66.641,38.865c-1.711,1.022-3.844,1.022-5.552,0l-66.643-38.865 c-0.678-0.395-0.96-1.374-0.632-2.186c0.12-0.314,0.343-0.581,0.63-0.758l66.643-38.864 C770.427,120.568,772.56,120.568,774.268,121.59z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 389.8066,
    y1: 669.1973,
    x2: 388.4278,
    y2: 669.6448,
    gradientTransform: "matrix(88.1718 0 0 -51.6361 -33541.0352 34723.8086)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00C2FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B78FF"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_12_)",
    d: "M774.268,117.785l66.643,38.865c0.678,0.395,0.961,1.374,0.633,2.186 c-0.121,0.314-0.344,0.581-0.631,0.758l-66.641,38.864c-1.711,1.022-3.844,1.022-5.552,0l-66.643-38.864 c-0.678-0.395-0.96-1.375-0.632-2.186c0.12-0.315,0.343-0.582,0.63-0.758l66.643-38.865 C770.427,116.763,772.56,116.763,774.268,117.785L774.268,117.785z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 370.0791,
    y1: 662.7891,
    x2: 367.6049,
    y2: 662.5738,
    gradientTransform: "matrix(18.8945 0 0 -10.977 -6169.5718 7458.439)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A22BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B0F89"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_13_)",
    d: "M794.677,176.588l2.542,1.287c0.253,0.148,0.359,0.512,0.236,0.816 c-0.045,0.118-0.128,0.218-0.236,0.284l-24.891,14.516c-0.653,0.382-1.417,0.382-2.072,0l-2.542-1.484 c-0.256-0.148-0.359-0.315-0.236-0.621c0.045-0.117,0.127-0.216,0.236-0.281l24.891-14.517 C793.257,176.207,794.021,176.207,794.677,176.588z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 391.1309,
    y1: 670.1328,
    x2: 392.4098,
    y2: 670.1007,
    gradientTransform: "matrix(158.0602 0 0 -85.0655 -61146.8711 57142.9258)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A22BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6607,
    style: {
      stopColor: "#0B0D7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A22BE"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_14_)",
    d: "M796.705,71.872l100.523,12.684v47.369c0.146,0.661,0.104,1.385-0.162,2.047 c-0.239,0.596-0.638,1.077-1.13,1.364L776.47,205.357c-3.143,1.842-6.81,1.842-9.95,0l-119.467-70.022 c-0.756-0.442-1.236-1.29-1.352-2.221h-0.024v-48.56h100.608l20.235-11.86c3.141-1.842,6.809-1.842,9.95,0L796.705,71.872z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B0F89",
    d: "M669.078,114.514c1.026,0.501,1.678,1.544,1.68,2.687v16.939c0,0.551-0.446,0.999-0.997,0.999 c-0.152,0-0.303-0.034-0.44-0.101l-3.118-1.524c-1.027-0.502-1.679-1.546-1.679-2.69v-16.939c0-0.551,0.447-0.998,0.999-0.998 c0.151,0,0.3,0.035,0.437,0.102L669.078,114.514z M659.436,109.203c1.029,0.502,1.681,1.547,1.681,2.69v16.939 c-0.001,0.551-0.447,0.999-0.999,0.998c-0.151,0-0.301-0.034-0.438-0.101l-3.118-1.523c-1.028-0.502-1.681-1.546-1.68-2.69 v-16.939c0-0.551,0.448-0.997,0.998-0.997c0.152,0,0.302,0.035,0.438,0.101L659.436,109.203z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 389.8901,
    y1: 669.8877,
    x2: 388.1325,
    y2: 670.2024,
    gradientTransform: "matrix(82.1547 0 0 -85.0655 -31126.6543 57142.4883)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F0856"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B0F89"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_15_)",
    d: "M796.116,83.826h100.524v47.369c0.145,0.661,0.104,1.385-0.163,2.047 c-0.239,0.596-0.638,1.077-1.131,1.364l-119.465,70.021c-3.144,1.842-6.812,1.842-9.95,0V71.966c3.139-1.842,6.807-1.842,9.95,0 L796.116,83.826z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B0F89",
    d: "M826.952,139.282l48.967-28.803c0.453-0.267,0.999-0.041,1.22,0.503c0.062,0.153,0.095,0.317,0.095,0.483 v4.481c0,1.257-0.598,2.407-1.538,2.961l-48.967,28.803c-0.452,0.266-0.998,0.042-1.219-0.505 c-0.063-0.153-0.094-0.316-0.092-0.48v-4.483c0-1.258,0.594-2.406,1.534-2.958V139.282z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 380.7593,
    y1: 667.6172,
    x2: 379.3799,
    y2: 668.2993,
    gradientTransform: "matrix(32.547 0 0 -23.5268 -11517.543 15845.2441)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00C2FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B78FF"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_16_)",
    d: "M829.379,140.882l48.966-28.804c0.454-0.266,1-0.042,1.222,0.504 c0.061,0.153,0.092,0.316,0.092,0.481v4.483c0,1.257-0.596,2.406-1.534,2.958l-48.969,28.805 c-0.452,0.268-0.998,0.042-1.219-0.503c-0.063-0.154-0.094-0.317-0.094-0.482v-4.481c0-1.258,0.596-2.408,1.535-2.962 L829.379,140.882z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 380.7578,
    y1: 667.0107,
    x2: 379.378,
    y2: 667.5208,
    gradientTransform: "matrix(32.547 0 0 -20.34 -11517.543 13714.0674)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00C2FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B78FF"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_17_)",
    d: "M829.379,154.833l48.966-28.804c0.454-0.266,1-0.04,1.222,0.504 c0.061,0.153,0.092,0.317,0.092,0.482v-0.592c0,1.257-0.596,2.407-1.534,2.959l-48.969,28.804 c-0.452,0.266-0.998,0.041-1.219-0.504c-0.063-0.153-0.094-0.316-0.094-0.48v0.59 C827.843,156.535,828.438,155.386,829.379,154.833L829.379,154.833z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B0F89",
    d: "M776.47,12.279l119.467,70.021c1.212,0.71,1.719,2.474,1.13,3.938c-0.239,0.596-0.638,1.077-1.13,1.364 L776.47,157.625c-3.143,1.842-6.81,1.842-9.95,0L647.053,87.604c-1.214-0.709-1.72-2.473-1.13-3.938 c0.237-0.595,0.636-1.076,1.13-1.364L766.52,12.279C769.66,10.438,773.327,10.438,776.47,12.279z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 392.5513,
    y1: 670.5488,
    x2: 390.3253,
    y2: 670.186,
    gradientTransform: "matrix(153.5756 0 0 -90.4187 -59375.5781 60699.6875)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#188EFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1B37D6"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_18_)",
    d: "M776.375,12.212l115.891,68.848c1.166,0.685,1.652,2.38,1.087,3.789 c-0.209,0.545-0.59,1.005-1.087,1.311l-114.893,67.342c-3.021,1.77-6.547,1.77-9.568,0L650.416,85.498 c-1.166-0.685-1.653-2.38-1.087-3.79c0.229-0.572,0.612-1.035,1.087-1.312l116.39-68.187c3.019-1.771,6.548-1.771,9.567,0 L776.375,12.212z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#00BDFA",
    d: "M774.496,33.583c-1.904-1.114-4.101-1.114-6.005,0l-86.073,50.451c-0.152,0.101-0.268,0.247-0.33,0.419 c-0.219,0.548-0.032,1.207,0.33,1.417l86.073,50.451c1.904,1.114,4.101,1.114,6.005,0l86.073-50.451 c0.152-0.1,0.27-0.247,0.33-0.419c0.221-0.547,0.032-1.207-0.33-1.417L774.496,33.583z M775.078,32.594l86.073,50.447 c0.874,0.513,1.239,1.784,0.813,2.839c-0.172,0.43-0.459,0.775-0.813,0.984l-86.073,50.448c-2.262,1.328-4.903,1.328-7.167,0 l-86.075-50.448c-0.875-0.513-1.239-1.783-0.814-2.839c0.173-0.43,0.46-0.775,0.814-0.984l86.075-50.447 C770.173,31.266,772.813,31.266,775.078,32.594z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 389.9492,
    y1: 669.9717,
    x2: 388.5607,
    y2: 669.9023,
    gradientTransform: "matrix(88.1718 0 0 -51.6361 -33541.0352 34678.1836)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A22BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B0F89"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_19_)",
    d: "M774.268,45.183l66.643,38.865c0.678,0.395,0.961,1.374,0.633,2.186 c-0.121,0.315-0.344,0.582-0.631,0.758l-66.641,38.865c-1.711,1.021-3.844,1.021-5.552,0l-66.643-38.865 c-0.678-0.395-0.96-1.375-0.632-2.186c0.12-0.315,0.343-0.582,0.63-0.758l66.643-38.865 C770.427,44.161,772.56,44.161,774.268,45.183z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 389.8066,
    y1: 669.748,
    x2: 388.4271,
    y2: 670.1958,
    gradientTransform: "matrix(88.1718 0 0 -51.6361 -33541.0352 34675.8086)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00C2FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B78FF"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_20_)",
    d: "M774.268,41.378l66.643,38.864c0.678,0.395,0.961,1.375,0.633,2.186 c-0.121,0.315-0.344,0.582-0.631,0.758l-66.641,38.865c-1.711,1.022-3.844,1.022-5.552,0l-66.643-38.865 c-0.678-0.395-0.96-1.374-0.632-2.186c0.12-0.314,0.343-0.581,0.63-0.758l66.643-38.864 C770.427,40.356,772.56,40.356,774.268,41.378L774.268,41.378z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 370.0781,
    y1: 665.3779,
    x2: 367.6053,
    y2: 665.1628,
    gradientTransform: "matrix(18.8945 0 0 -10.977 -6169.5718 7410.4468)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A22BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B0F89"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_21_)",
    d: "M794.677,100.181l2.542,1.287c0.253,0.148,0.359,0.513,0.236,0.817 c-0.045,0.117-0.128,0.218-0.236,0.283l-24.891,14.517c-0.653,0.381-1.417,0.381-2.072,0l-2.542-1.484 c-0.256-0.148-0.359-0.315-0.236-0.621c0.045-0.117,0.127-0.217,0.236-0.282l24.891-14.516 C793.257,99.799,794.021,99.799,794.677,100.181z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 391.1309,
    y1: 670.4648,
    x2: 392.4102,
    y2: 670.4327,
    gradientTransform: "matrix(158.0602 0 0 -85.0655 -61146.8711 57095.1133)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A22BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6607,
    style: {
      stopColor: "#0B0D7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A22BE"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_22_)",
    d: "M796.705-4.227L897.229,8.457v47.37c0.146,0.659,0.104,1.384-0.162,2.046 c-0.239,0.596-0.638,1.076-1.13,1.364L776.47,129.259c-3.143,1.843-6.81,1.843-9.95,0L647.053,59.237 c-0.756-0.44-1.236-1.29-1.352-2.221h-0.024V8.457h100.608l20.235-11.861c3.141-1.841,6.809-1.841,9.95,0L796.705-4.227z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B0F89",
    d: "M669.078,38.415c1.027,0.502,1.68,1.545,1.68,2.689v16.939c0,0.551-0.448,0.997-1,0.997 c-0.151,0-0.3-0.035-0.438-0.101l-3.118-1.523c-1.027-0.502-1.679-1.545-1.679-2.689V37.788c0-0.551,0.447-0.998,0.999-0.998 c0.151,0,0.3,0.035,0.437,0.101L669.078,38.415L669.078,38.415z M659.436,33.106c1.028,0.501,1.68,1.544,1.681,2.687v16.941 c-0.001,0.551-0.447,0.998-0.999,0.998c-0.151,0-0.301-0.035-0.438-0.101l-3.118-1.523c-1.028-0.502-1.68-1.545-1.68-2.689V32.479 c0-0.551,0.448-0.998,0.998-0.997c0.152,0,0.302,0.035,0.438,0.101L659.436,33.106z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 389.8901,
    y1: 670.2197,
    x2: 388.1325,
    y2: 670.5344,
    gradientTransform: "matrix(82.1547 0 0 -85.0655 -31126.6543 57094.668)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F0856"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B0F89"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_23_)",
    d: "M796.116,7.728h100.524v47.369c0.145,0.659,0.104,1.383-0.163,2.046 c-0.239,0.595-0.638,1.076-1.131,1.364l-119.465,70.021c-3.144,1.842-6.812,1.842-9.95,0V-4.135c3.139-1.841,6.807-1.841,9.95,0 l20.234,11.861V7.728z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B0F89",
    d: "M826.952,63.184l48.967-28.803c0.453-0.267,0.999-0.042,1.22,0.505c0.062,0.152,0.095,0.315,0.095,0.48 v4.483c0,1.258-0.598,2.406-1.538,2.958l-48.967,28.804c-0.452,0.267-0.998,0.041-1.219-0.503 c-0.063-0.153-0.094-0.317-0.092-0.483v-4.481C825.418,64.887,826.012,63.738,826.952,63.184z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 380.7598,
    y1: 668.8203,
    x2: 379.3809,
    y2: 669.5022,
    gradientTransform: "matrix(32.547 0 0 -23.528 -11517.5371 15798.2422)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00C2FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B78FF"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_24_)",
    d: "M829.379,64.784l48.966-28.804c0.454-0.266,1-0.041,1.222,0.504 c0.061,0.153,0.092,0.317,0.092,0.482v4.481c0,1.258-0.596,2.406-1.534,2.958l-48.969,28.807 c-0.452,0.266-0.998,0.041-1.219-0.504c-0.063-0.153-0.094-0.317-0.094-0.483v-4.481c0-1.258,0.596-2.407,1.535-2.959 L829.379,64.784z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 380.7588,
    y1: 668.4043,
    x2: 379.3779,
    y2: 668.9147,
    gradientTransform: "matrix(32.547 0 0 -20.3406 -11517.543 13666.6807)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00C2FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B78FF"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_25_)",
    d: "M829.379,78.736l48.966-28.806c0.454-0.266,1-0.04,1.222,0.505 c0.061,0.153,0.092,0.317,0.092,0.482v-0.592c0,1.258-0.596,2.407-1.534,2.961l-48.969,28.803 c-0.452,0.267-0.998,0.041-1.219-0.504c-0.063-0.153-0.094-0.316-0.094-0.481v0.591C827.843,80.437,828.438,79.289,829.379,78.736 L829.379,78.736z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B0F89",
    d: "M776.47-63.819L895.937,6.203c1.212,0.711,1.719,2.473,1.13,3.939c-0.239,0.594-0.638,1.076-1.13,1.364 L776.47,81.527c-3.143,1.841-6.81,1.841-9.95,0L647.053,11.506c-1.214-0.711-1.72-2.475-1.13-3.939 c0.237-0.596,0.636-1.075,1.13-1.364L766.52-63.819C769.66-65.662,773.327-65.662,776.47-63.819z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 392.5508,
    y1: 670.8613,
    x2: 390.3262,
    y2: 670.4988,
    gradientTransform: "matrix(153.5756 0 0 -90.417 -59375.5781 60650.707)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#188EFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1B37D6"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_26_)",
    d: "M776.375-63.886L892.266,4.962c1.166,0.685,1.652,2.38,1.087,3.79 c-0.209,0.545-0.59,1.006-1.087,1.312L777.373,77.404c-3.021,1.77-6.547,1.77-9.568,0L650.416,9.4 c-1.166-0.684-1.653-2.38-1.087-3.789c0.229-0.571,0.612-1.033,1.087-1.312l116.39-68.186c3.019-1.771,6.548-1.771,9.567,0 H776.375z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#00BDFA",
    d: "M774.496-42.514c-1.904-1.118-4.101-1.118-6.005,0L682.418,7.935c-0.152,0.101-0.27,0.248-0.33,0.42 c-0.219,0.549-0.032,1.207,0.33,1.417l86.073,50.45c1.904,1.115,4.101,1.115,6.005,0l86.073-50.45 c0.152-0.101,0.27-0.248,0.33-0.419c0.221-0.548,0.032-1.207-0.33-1.417l-86.073-50.451V-42.514z M775.078-43.505l86.073,50.45 c0.874,0.511,1.239,1.783,0.813,2.837c-0.172,0.43-0.459,0.775-0.813,0.983l-86.073,50.45c-2.262,1.326-4.903,1.326-7.167,0 l-86.075-50.451c-0.875-0.511-1.239-1.782-0.814-2.836c0.173-0.43,0.46-0.776,0.814-0.982l86.075-50.451 c2.262-1.325,4.901-1.325,7.167,0V-43.505z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 390.062,
    y1: 670.6455,
    x2: 387.8347,
    y2: 670.2864,
    gradientTransform: "matrix(88.1713 0 0 -51.6361 -33540.8906 34628.7148)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#188EFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1B37D6"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "url(#SVGID_27_)",
    enableBackground: "new    ",
    d: "M774.117-33.578L840.76,5.287 c0.676,0.395,0.958,1.373,0.63,2.186c-0.12,0.315-0.343,0.582-0.63,0.758l-66.643,38.863c-1.709,1.022-3.842,1.022-5.552,0 L701.925,8.23c-0.677-0.395-0.961-1.374-0.632-2.188c0.121-0.314,0.344-0.581,0.632-0.756l66.639-38.866 c1.711-1.022,3.844-1.022,5.552,0L774.117-33.578z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 392.1841,
    y1: 671.0791,
    x2: 392.1841,
    y2: 669.2189,
    gradientTransform: "matrix(183.1643 0 0 -131.746 -71063.6797 88498.1875)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6BE9FF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#01F3FA"
    }
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_28_)",
    d: "M915.849,86.182c0.448,82.534,0.448,124.364,0,125.494c-0.275,0.689-0.732,1.246-1.296,1.581 l-137.006,81.068c-3.601,2.133-7.808,2.133-11.41,0l-139.975-81.866c-1.39-0.822-1.971-2.865-1.297-4.559 c0.184-0.46,0.184-41.031,0-121.718H915.849z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 388.8853,
    y1: 671.0762,
    x2: 388.8853,
    y2: 669.216,
    gradientTransform: "matrix(88.9148 0 0 -130.742 -33882.3164 87824.0078)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6BE9FF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#01F3FA"
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_29_)",
    d: "M766.139,86.182v208.143l-139.977-81.866c-1.39-0.822-1.971-2.865-1.297-4.559 c0.184-0.46,0.184-41.031,0-121.718H766.139z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 344.6606,
    y1: 671.043,
    x2: 344.6606,
    y2: 669.0522,
    gradientTransform: "matrix(11.155 0 0 -158.54 -3197.3506 106421.6094)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6BE9FF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#01F3FA"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_30_)",
    d: "M638.461-23.377l17.76,10.146v242.253l-17.76-10.147V-23.377z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 346.228,
    y1: 670.7881,
    x2: 346.228,
    y2: 668.9877,
    gradientTransform: "matrix(11.155 0 0 -158.54 -3167.8354 106439.2422)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6BE9FF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#01F3FA"
    }
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_31_)",
    d: "M685.455,4.769l17.758,10.145v242.252l-17.758-10.146V4.769z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 347.7925,
    y1: 670.2539,
    x2: 347.7925,
    y2: 668.923,
    gradientTransform: "matrix(11.155 0 0 -158.54 -3138.3501 106456.7422)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6BE9FF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#01F3FA"
    }
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_32_)",
    d: "M732.389,32.671l17.76,10.146V285.07l-17.76-10.148V32.671z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 437.1479,
    y1: 671.0391,
    x2: 437.1479,
    y2: 669.0471,
    gradientTransform: "matrix(-11.155 0 0 -158.54 5769.4443 106422.7344)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6BE9FF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#01F3FA"
    }
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_33_)",
    d: "M901.945-21.495l-17.76,10.146v242.253l17.76-10.147V-21.495z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 438.7148,
    y1: 670.7832,
    x2: 438.7148,
    y2: 668.9828,
    gradientTransform: "matrix(-11.155 0 0 -158.54 5739.9292 106440.4922)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6BE9FF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#01F3FA"
    }
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_34_)",
    d: "M854.953,6.649l-17.76,10.146v242.253l17.76-10.148V6.649z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 440.2808,
    y1: 670.249,
    x2: 440.2808,
    y2: 668.9173,
    gradientTransform: "matrix(-11.155 0 0 -158.54 5710.4517 106457.9922)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6BE9FF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#01F3FA"
    }
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_35_)",
    d: "M808.018,34.553L790.26,44.699v242.252l17.758-10.147V34.553z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 392.8086,
    y1: 670.3594,
    x2: 392.9619,
    y2: 669.3264,
    gradientTransform: "matrix(159.3904 0 0 -141.026 -61365.1484 94831.5859)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#02E8FD",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3049,
    style: {
      stopColor: "#02E5FD",
      stopOpacity: 0.385
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#01CCFB",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 392.8638,
    y1: 670.3145,
    x2: 392.7691,
    y2: 669.5211,
    gradientTransform: "matrix(159.3904 0 0 -141.026 -61365.1484 94831.5859)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#01E4FC",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2365,
    style: {
      stopColor: "#02EBFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#01E2FB",
      stopOpacity: 0
    }
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_36_)",
    stroke: "url(#SVGID_37_)",
    strokeWidth: 1.444,
    d: "M1278.451,263.884l89.248,53.183 c1.749,1.042,2.322,3.306,1.281,5.053c-0.325,0.544-0.785,0.998-1.336,1.313l-233.896,133.895l8.94,15.615l233.896-133.895 c3.238-1.854,5.943-4.509,7.854-7.715c6.13-10.285,2.761-23.594-7.524-29.723l-89.25-53.184L1278.451,263.884z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1246.944 313.662)",
    filter: "url(#C)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: -911.5963,
    y1: 304.2579,
    x2: -913.8215,
    y2: 303.9093,
    gradientTransform: "matrix(5.018 0 0 -2.897 4672.0654 919.1726)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#188EFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1B37D6"
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_38_)",
    d: "M93.05,40.455l-3.994-2.307l3.994-2.306l3.994,2.306L93.05,40.455z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: -972.5592,
    y1: 321.5099,
    x2: -973.0192,
    y2: 322.8154,
    gradientTransform: "matrix(2.509 0 0 -4.345 2535.791 1434.4253)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00C2FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B78FF"
    }
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_39_)",
    d: "M97.044,38.149l-3.994-2.306v-4.611l3.994,2.304V38.149z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: -971.3883,
    y1: 319.0079,
    x2: -973.7442,
    y2: 322.7282,
    gradientTransform: "matrix(2.509 0 0 -4.345 2533.2813 1434.4253)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00C2FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B78FF"
    }
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_40_)",
    d: "M93.05,35.843l-3.994,2.306v-4.613l3.994-2.304V35.843z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1201.527 339.952)",
    filter: "url(#G)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: -871.5084,
    y1: 272.5968,
    x2: -873.7372,
    y2: 272.2477,
    gradientTransform: "matrix(5.018 0 0 -2.897 4444.1616 843.0095)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#188EFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1B37D6"
    }
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_41_)",
    d: "M66.162,56.02l-3.994-2.307l3.994-2.306l3.994,2.306L66.162,56.02z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: -937.8053,
    y1: 291.6339,
    x2: -938.2653,
    y2: 292.9395,
    gradientTransform: "matrix(2.509 0 0 -4.345 2421.8408 1320.1943)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00C2FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B78FF"
    }
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_42_)",
    d: "M70.157,53.713l-3.994-2.306v-4.613l3.994,2.308V53.713z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: -936.6857,
    y1: 289.1359,
    x2: -939.0414,
    y2: 292.8558,
    gradientTransform: "matrix(2.509 0 0 -4.345 2419.3311 1320.1943)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00C2FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B78FF"
    }
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_43_)",
    d: "M66.162,51.407l-3.994,2.306v-4.611l3.994-2.308V51.407z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 381.7383,
    y1: 661.6133,
    x2: 383.1702,
    y2: 662.2444,
    gradientTransform: "matrix(24.775 0 0 -17.527 -8164.8945 11969.834)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00F6FF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#02CDE7"
    }
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_44_)",
    d: "M1284.11,381.905v-4.613l35.449-20.985v4.613l3.994,2.304l-35.447,20.985l-2.959-1.707 L1284.11,381.905z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1234.108 320.95)",
    filter: "url(#I)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00F6FF",
    d: "M85.452,44.581l-3.994-2.308l3.994-2.304l3.994,2.304L85.452,44.581z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#03E2F9",
    d: "M89.446,42.274l-3.994-2.304v-4.613l3.994,2.306V42.274z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#69E0FF",
    d: "M85.452,39.97l-3.994,2.304v-4.611l3.994-2.306V39.97z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 383.4883,
    y1: 663.1338,
    x2: 382.1505,
    y2: 663.6946,
    gradientTransform: "matrix(24.775 0 0 -17.527 -8135.8936 11923.1465)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00F6FF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#02CDE7"
    }
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_45_)",
    d: "M1369.709,307.571l-3.993,2.306l-35.449-20.987l3.994-2.304v-4.613l35.448,20.987V307.571z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1243.296 274.214)",
    filter: "url(#J)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00F6FF",
    d: "M90.965,16.983l-3.994-2.308l3.994-2.304l3.995,2.304L90.965,16.983z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#03E2F9",
    d: "M86.971,14.676v-4.609l3.994-2.308v4.613L86.971,14.676z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#69E0FF",
    d: "M90.965,12.372V7.759l3.995,2.308v4.609L90.965,12.372z"
  })))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#01E5FB",
    d: "M1149.181,204.023l1.15-1.99l198.059,114.419c1.648,0.951,2.214,3.058,1.264,4.707 c-0.305,0.529-0.744,0.966-1.272,1.269l-181.697,104.246l-1.143-1.996l181.695-104.244c0.55-0.317,0.74-1.021,0.423-1.569 c-0.102-0.175-0.246-0.319-0.42-0.421l-198.059-114.418V204.023z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 394.4946,
    y1: 669.7432,
    x2: 393.2935,
    y2: 669.6335,
    gradientTransform: "matrix(413.6331 0 0 -164.1688 -162112.5156 110468.25)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#02E8FD",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3779,
    style: {
      stopColor: "#02E5FD",
      stopOpacity: 0.385
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#01CCFB",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#01CCFB",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 394.3662,
    y1: 669.5859,
    x2: 393.3662,
    y2: 669.4848,
    gradientTransform: "matrix(413.6331 0 0 -164.1688 -162112.5156 110468.25)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#01E4FC",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3512,
    style: {
      stopColor: "#02EBFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#01E2FB",
      stopOpacity: 0
    }
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_46_)",
    stroke: "url(#SVGID_47_)",
    strokeWidth: 1.444,
    d: "M419.413,655.387l27.417,7.579l397.826-236.741 c9-5.355,20.188-5.455,29.281-0.256l190.179,108.708c6.202,3.545,10.804,1.514,12.888-4.232 c1.926-5.311,0.728-11.634-2.696-13.593L884.13,408.144c-15.52-8.869-34.612-8.705-49.975,0.437L419.411,655.387H419.413z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 393.7539,
    y1: 669.5352,
    x2: 392.8276,
    y2: 669.2823,
    gradientTransform: "matrix(314.882 0 0 -138.2866 -123116.1953 93109.8438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#11D1FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4FDCFF",
      stopOpacity: 0
    }
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_48_)",
    d: "M482.613,656.014l-1.152-1.988l374.504-216.929c2.8-1.623,6.247-1.652,9.076-0.081l117.72,65.415 l-1.116,2.009l-117.72-65.415c-2.122-1.178-4.708-1.156-6.808,0.06L482.613,656.014z"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(875.312 390.014)",
    filter: "url(#N)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00F6FF",
    d: "M-126.962,85.657l-3.994-2.309l3.994-2.305l3.994,2.308L-126.962,85.657z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#03E2F9",
    d: "M-122.968,83.351l-3.994-2.308v-4.611l3.994,2.306V83.351z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#69E0FF",
    d: "M-126.962,81.044l-3.994,2.308v-4.613l3.994-2.306V81.044z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(982.48 370.36)",
    filter: "url(#O)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00F6FF",
    d: "M-63.517,74.022l-3.994-2.309l3.994-2.304l3.994,2.306L-63.517,74.022z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#03E2F9",
    d: "M-59.523,71.715l-3.994-2.306v-4.613l3.994,2.306V71.715z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#69E0FF",
    d: "M-63.517,69.41l-3.994,2.306v-4.613l3.994-2.306V69.41z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 374.0103,
    y1: 659.9746,
    x2: 375.4422,
    y2: 660.6057,
    gradientTransform: "matrix(24.775 0 0 -17.527 -8488.3008 12018.3652)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00F6FF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#02CDE7"
    }
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_49_)",
    d: "M769.243,459.171v-4.611l35.447-20.985v4.611l3.994,2.306l-35.447,20.986l-2.959-1.707 L769.243,459.171z"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(910.701 369.484)",
    filter: "url(#P)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00F6FF",
    d: "M-106.012,73.313l-3.994-2.306l3.994-2.306l3.993,2.306L-106.012,73.313z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#03E2F9",
    d: "M-102.018,71.007l-3.993-2.306V64.09l3.993,2.304V71.007z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#69E0FF",
    d: "M-106.012,68.702l-3.994,2.306v-4.613l3.994-2.304V68.702z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(729.029 307.169)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.15,
    fill: "#03E1F9",
    enableBackground: "new    ",
    cx: -59.426,
    cy: 95.026,
    rx: 12.193,
    ry: 12.193
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#03E1F9",
    cx: -59.426,
    cy: 95.026,
    rx: 2.537,
    ry: 2.537
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.3,
    fill: "#03E1F9",
    enableBackground: "new    ",
    cx: -59.426,
    cy: 95.026,
    rx: 7.101,
    ry: 7.101
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: -623.799,
    y1: 359.4394,
    x2: -623.799,
    y2: 357.5424,
    gradientTransform: "matrix(1.594 0 0 -33.461 934.9105 12070.7725)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#04F1FC",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03E1F9"
    }
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_50_)",
    d: "M-60.695,41.12h2.537v53.271h-2.537V41.12z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(864.151 415.949)"
  }, _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.15,
    fill: "#03E1F9",
    enableBackground: "new    ",
    cx: -124.88,
    cy: 146.135,
    rx: 12.194,
    ry: 12.194
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#03E1F9",
    cx: -124.88,
    cy: 146.135,
    rx: 2.536,
    ry: 2.536
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.3,
    fill: "#03E1F9",
    enableBackground: "new    ",
    cx: -124.88,
    cy: 146.135,
    rx: 7.1,
    ry: 7.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: -799.9835,
    y1: 249.1311,
    x2: -799.9835,
    y2: 247.2322,
    gradientTransform: "matrix(1.594 0 0 -33.461 1150.295 8430.8857)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#04F1FC",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03E1F9"
    }
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_51_)",
    d: "M-126.148,92.231h2.537v53.271h-2.537V92.231z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1038.25 97.403)"
  }, _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.15,
    fill: "#03E1F9",
    enableBackground: "new    ",
    cx: -21.811,
    cy: -42.45,
    rx: 12.193,
    ry: 12.193
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#03E1F9",
    cx: -21.811,
    cy: -42.45,
    rx: 2.536,
    ry: 2.536
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.3,
    fill: "#03E1F9",
    enableBackground: "new    ",
    cx: -21.811,
    cy: -42.45,
    rx: 7.1,
    ry: 7.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: -909.4209,
    y1: 573.3118,
    x2: -909.4209,
    y2: 571.416,
    gradientTransform: "matrix(1.594 0 0 -33.461 1427.8086 19089.7676)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#04F1FC",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03E1F9"
    }
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_52_)",
    d: "M-23.079-96.354h2.538v53.271h-2.538V-96.354z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(777.54 97.976)"
  }, _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.15,
    fill: "#03E1F9",
    enableBackground: "new    ",
    cx: -176.155,
    cy: -42.111,
    rx: 12.193,
    ry: 12.193
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#03E1F9",
    cx: -176.155,
    cy: -42.11,
    rx: 2.536,
    ry: 2.536
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.3,
    fill: "#03E1F9",
    enableBackground: "new    ",
    cx: -176.155,
    cy: -42.111,
    rx: 7.101,
    ry: 7.101
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: -745.54,
    y1: 572.73,
    x2: -745.54,
    y2: 570.8342,
    gradientTransform: "matrix(1.594 0 0 -33.461 1012.2369 19070.584)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#04F1FC",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03E1F9"
    }
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_53_)",
    d: "M-177.424-96.015h2.537v53.27h-2.537V-96.015z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(960.899 283.048)"
  }, _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.15,
    fill: "#03E1F9",
    enableBackground: "new    ",
    cx: -67.603,
    cy: 67.455,
    rx: 12.193,
    ry: 12.193
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#03E1F9",
    cx: -67.603,
    cy: 67.455,
    rx: 2.537,
    ry: 2.537
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.3,
    fill: "#03E1F9",
    enableBackground: "new    ",
    cx: -67.603,
    cy: 67.456,
    rx: 7.1,
    ry: 7.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: -860.7989,
    y1: 384.3817,
    x2: -860.7989,
    y2: 382.4859,
    gradientTransform: "matrix(1.594 0 0 -33.461 1304.5115 12877.8809)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#04F1FC",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03E1F9"
    }
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_54_)",
    d: "M-68.872,13.551h2.537v53.271h-2.537V13.551z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 389.7109,
    y1: 670.2637,
    x2: 391.8474,
    y2: 670.2637,
    gradientTransform: "matrix(75.5642 0 0 -107.8558 -28220.6465 72442.5313)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A22BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6374,
    style: {
      stopColor: "#0B0D7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A22BE"
    }
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_55_)",
    d: "M1373.477,86.516v124.893c0.09,0.414,0.063,0.866-0.103,1.281 c-0.136,0.354-0.383,0.655-0.708,0.854l-37.588,22.139c-1.915,1.152-4.311,1.152-6.227,0l-74.764-43.819 c-0.472-0.276-0.773-0.808-0.845-1.39h-0.016V64.838L1373.477,86.516z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B0F89",
    d: "M1266.597,180.046c0.642,0.314,1.051,0.966,1.051,1.683v10.602c0,0.345-0.278,0.625-0.623,0.625 c-0.095,0-0.189-0.022-0.275-0.064l-1.952-0.953c-0.643-0.314-1.052-0.967-1.052-1.683v-10.601c0-0.345,0.28-0.625,0.625-0.625 c0.095,0,0.19,0.021,0.275,0.063L1266.597,180.046z M1260.563,176.724c0.645,0.313,1.052,0.966,1.052,1.683v10.602 c0,0.345-0.278,0.624-0.624,0.625c-0.095,0-0.189-0.022-0.275-0.065l-1.952-0.954c-0.643-0.314-1.05-0.967-1.05-1.682V176.33 c-0.001-0.344,0.278-0.624,0.624-0.624c0.095,0,0.189,0.021,0.274,0.063L1260.563,176.724z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: 384.2363,
    y1: 670.2246,
    x2: 384.0291,
    y2: 670.4868,
    gradientTransform: "matrix(28.0622 0 0 -95.8328 -9433.6875 64380.9609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F0856"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B0F89"
    }
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_56_)",
    d: "M1373.334,86.282v124.893c0.091,0.414,0.063,0.866-0.102,1.28 c-0.135,0.355-0.384,0.656-0.707,0.855l-37.589,22.141c-1.917,1.152-4.311,1.152-6.227,0V83.747L1373.334,86.282z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B0F89",
    d: "M1297.902,41.286l74.766,43.82c0.757,0.446,1.074,1.548,0.706,2.464c-0.136,0.354-0.383,0.655-0.706,0.854 l-37.59,22.142c-1.915,1.152-4.311,1.152-6.227,0l-74.764-43.82c-0.761-0.445-1.076-1.548-0.708-2.464 c0.136-0.354,0.384-0.654,0.708-0.854l37.59-22.141C1293.593,40.134,1295.986,40.134,1297.902,41.286z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: 391.5933,
    y1: 669.958,
    x2: 389.3691,
    y2: 669.5933,
    gradientTransform: "matrix(72.758 0 0 -42.967 -27112.2129 28854.4023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#188EFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1B37D6"
    }
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_57_)",
    d: "M1297.847,41.244l72.523,43.084c0.729,0.429,1.034,1.49,0.68,2.373 c-0.131,0.341-0.368,0.629-0.68,0.82l-34.728,20.465c-1.842,1.108-4.145,1.108-5.987,0l-73.463-42.558 c-0.728-0.429-1.034-1.49-0.679-2.373c0.145-0.357,0.384-0.647,0.679-0.82l35.663-20.992 C1293.698,40.136,1296.002,40.136,1297.847,41.244z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#00BDFA",
    d: "M1292.839,54.492l-16.693,9.894c-0.123,0.079-0.216,0.197-0.268,0.334 c-0.163,0.407-0.022,0.896,0.268,1.066l53.864,31.57c1.2,0.725,2.702,0.726,3.902,0.003l16.694-9.894 c0.123-0.079,0.218-0.197,0.268-0.334c0.163-0.406,0.022-0.896-0.268-1.067l-53.865-31.57c-1.199-0.724-2.701-0.724-3.901-0.001 L1292.839,54.492z M1351.188,85.074c0.804,0.471,1.119,1.571,0.752,2.485c-0.153,0.382-0.416,0.7-0.749,0.896l-16.694,9.893 c-1.56,0.936-3.508,0.936-5.067,0l-53.865-31.57c-0.803-0.473-1.119-1.572-0.753-2.486c0.155-0.382,0.417-0.701,0.75-0.895 l16.694-9.894c1.559-0.936,3.507-0.936,5.068,0l53.864,31.57V85.074z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: 385.9341,
    y1: 668.2715,
    x2: 384.5474,
    y2: 668.2017,
    gradientTransform: "matrix(31.8292 0 0 -18.6986 -10945.3066 12571.2881)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A22BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B0F89"
    }
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_58_)",
    d: "M1296.527,61.878l41.704,24.322c0.425,0.247,0.6,0.86,0.394,1.368 c-0.075,0.197-0.213,0.364-0.394,0.474l-4.53,2.643c-1.07,0.64-2.404,0.64-3.474,0L1288.52,66.36 c-0.424-0.247-0.6-0.86-0.395-1.368c0.076-0.197,0.214-0.364,0.395-0.474l4.53-2.643c1.069-0.639,2.405-0.639,3.475,0 L1296.527,61.878z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_59_",
    gradientUnits: "userSpaceOnUse",
    x1: 385.791,
    y1: 668.0703,
    x2: 384.4116,
    y2: 668.5208,
    gradientTransform: "matrix(31.8292 0 0 -18.6966 -10945.3066 12568.4629)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00C2FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B78FF"
    }
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_59_)",
    d: "M1296.527,59.497l41.704,24.321c0.425,0.247,0.6,0.86,0.394,1.369 c-0.075,0.197-0.213,0.363-0.394,0.473l-4.53,2.643c-1.07,0.64-2.404,0.64-3.474,0l-41.708-24.321 c-0.424-0.247-0.6-0.859-0.395-1.37c0.076-0.197,0.214-0.363,0.395-0.473v0.135v-0.135l4.53-2.642c1.069-0.64,2.405-0.64,3.475,0 H1296.527z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientUnits: "userSpaceOnUse",
    x1: 371.6387,
    y1: 662.5947,
    x2: 369.1645,
    y2: 662.3795,
    gradientTransform: "matrix(11.8243 0 0 -6.8691 -3022.542 4646.0439)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A22BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B0F89"
    }
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_60_)",
    d: "M1354.17,90.614l1.592,0.806c0.157,0.092,0.223,0.32,0.146,0.509 c-0.027,0.075-0.081,0.138-0.149,0.179l-15.575,9.084c-0.399,0.239-0.898,0.239-1.298,0l-1.592-0.928 c-0.159-0.092-0.223-0.197-0.146-0.389c0.028-0.073,0.079-0.134,0.146-0.175l15.578-9.086 C1353.271,90.376,1353.771,90.376,1354.17,90.614z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_61_",
    gradientUnits: "userSpaceOnUse",
    x1: 392.1875,
    y1: 671.0127,
    x2: 392.1875,
    y2: 669.1514,
    gradientTransform: "matrix(122.649 0 0 -103.55 -46871.7734 69556.3828)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6BE9FF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#01F3FA"
    }
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    fill: "url(#SVGID_61_)",
    enableBackground: "new    ",
    d: "M1327.063,73.066h-194.921 c0.082,110.109,0.082,165.06,0,164.853c-0.451-1.135-0.063-2.502,0.869-3.054l93.766-54.836c2.413-1.428,5.23-1.428,7.642,0 l91.777,54.305c0.378,0.223,0.685,0.597,0.867,1.059c0.201,0.504,0.201-53.603,0-162.325V73.066z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_62_",
    gradientUnits: "userSpaceOnUse",
    x1: 388.894,
    y1: 670.9541,
    x2: 388.894,
    y2: 669.0928,
    gradientTransform: "matrix(59.5615 0 0 -98.214 -21983.7285 65978.5781)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6BE9FF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#01F3FA"
    }
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fill: "url(#SVGID_62_)",
    enableBackground: "new    ",
    d: "M1226.777,81.562h-94.635 c0.082,104.444,0.082,156.564,0,156.358c-0.451-1.136-0.063-2.504,0.869-3.055l93.766-54.836V81.562z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 -1 1124.387 242.045)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_63_",
    gradientUnits: "userSpaceOnUse",
    x1: -732.4988,
    y1: -429.0126,
    x2: -732.4988,
    y2: -433.4178,
    gradientTransform: "matrix(110.867 0 0 130.577 81315.1172 56197.7422)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6BE9FF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#01F3FA"
    }
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_63_)",
    d: "M16.863,11.852l11.896,6.796v162.277l-11.896-6.796V11.852z M48.343,30.705l11.896,6.798V199.78 l-11.896-6.798V30.705z M79.782,49.397l11.898,6.798v162.277l-11.898-6.797V49.397z M193.366,13.113l-11.896,6.798v162.275 l11.896-6.796V13.113z M161.883,31.965l-11.893,6.798v162.278l11.895-6.798L161.883,31.965z M130.445,50.658l-11.896,6.798 v162.277l11.896-6.797V50.658z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_64_",
    gradientUnits: "userSpaceOnUse",
    x1: 372.3389,
    y1: 669.8438,
    x2: 372.163,
    y2: 668.797,
    gradientTransform: "matrix(15.5066 0 0 -55.172 -4564.1743 37123.2188)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#188EFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1B37D6"
    }
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "url(#SVGID_64_)",
    enableBackground: "new    ",
    d: "M1196.458,157.132l9.019,5.539 c-0.648,1.39-0.979,2.863-0.866,4.133l5.175,57.774c0.846,9.418,4.544,16.442,10.353,20.14l-8.649-5.01l0.039,0.001 c-6.106-3.604-10.016-10.748-10.883-20.446l-5.176-57.773c-0.216-2.404,1.561-5.513,0.987-4.359H1196.458z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_65_",
    gradientUnits: "userSpaceOnUse",
    x1: 386.394,
    y1: 665.2041,
    x2: 384.1672,
    y2: 665.0967,
    gradientTransform: "matrix(34.706 0 0 -11.1157 -12108.5176 7505.4429)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#188EFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1B37D6"
    }
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "url(#SVGID_65_)",
    enableBackground: "new    ",
    d: "M1242.949,115.28l44.092-12.257 c0.822-0.229,1.539-0.148,2.101,0.187l9.061,5.265c-0.549-0.295-1.235-0.356-2.02-0.139l-44.09,12.254l-9.144-5.312V115.28z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_66_",
    gradientUnits: "userSpaceOnUse",
    x1: 385.728,
    y1: 668.0273,
    x2: 384.3488,
    y2: 668.9744,
    gradientTransform: "matrix(34.945 0 0 -29.768 -12232.0215 20038.2578)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00C2FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B78FF"
    }
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fill: "url(#SVGID_66_)",
    enableBackground: "new    ",
    d: "M1205.477,162.67l-9.018-5.539 c0.598-1.207,1.417-2.34,2.4-3.203l44.09-38.649l9.144,5.311l-44.092,38.649C1206.955,160.159,1206.08,161.378,1205.477,162.67z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_67_",
    gradientUnits: "userSpaceOnUse",
    x1: 389.7412,
    y1: 669.3877,
    x2: 389.1234,
    y2: 670.6935,
    gradientTransform: "matrix(59.6776 0 0 -89.1829 -21983.9063 59930.9727)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00C2FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B78FF"
    }
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fill: "url(#SVGID_67_)",
    enableBackground: "new    ",
    d: "M1208.001,159.24 c-2.172,1.904-3.608,5.112-3.391,7.564l5.175,57.774c1.188,13.263,8.044,21.779,18.47,22.946l23.838,2.665l23.837-30.186 c10.428-13.204,17.282-29.634,18.469-44.271l5.177-63.748c0.219-2.703-1.219-4.25-3.393-3.646l-44.088,12.253L1208.001,159.24z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_68_",
    gradientUnits: "userSpaceOnUse",
    x1: 387.8169,
    y1: 669.0439,
    x2: 387.1994,
    y2: 670.349,
    gradientTransform: "matrix(44.5026 0 0 -66.5063 -15989.7676 44714.9336)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00C2FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B78FF"
    }
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_68_)",
    d: "M1219.213,164.315c-1.619,1.42-2.69,3.811-2.528,5.64l3.858,43.082 c0.887,9.893,5.998,16.244,13.773,17.114l17.776,1.985l17.776-22.511c7.775-9.845,12.886-22.097,13.771-33.013l3.86-47.538 c0.163-2.017-0.907-3.171-2.529-2.719l-32.879,9.138L1219.213,164.315z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#00BDFA",
    d: "M1251.812,128.679l0.128-0.033l38.873-10.805c2.342-0.653,3.939,1.066,3.716,3.816l-4.56,56.207 c-1.059,13.022-7.146,27.615-16.408,39.343l-21.216,26.865l-21.334-2.385c-9.489-1.062-15.723-8.804-16.792-20.752l-4.563-50.938 c-0.21-2.354,1.137-5.358,3.185-7.152L1251.812,128.679L1251.812,128.679z M1252.373,129.718l-38.777,33.991 c-1.783,1.563-2.972,4.216-2.796,6.185l4.563,50.938c1.025,11.445,6.879,18.719,15.776,19.713l20.7,2.313l20.82-26.364 c9.125-11.558,15.124-25.936,16.161-38.726l4.563-56.205c0.164-2.022-0.776-3.031-2.264-2.618L1252.373,129.718L1252.373,129.718z "
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_69_",
    gradientUnits: "userSpaceOnUse",
    x1: 388.894,
    y1: 670.5801,
    x2: 388.894,
    y2: 668.7188,
    gradientTransform: "matrix(59.5615 0 0 -87.582 -21983.7207 58884.6797)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6BE9FF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#01F3FA"
    }
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_69_)",
    d: "M1226.777,153.985v139.429l-93.764-54.842c-0.934-0.551-1.322-1.918-0.871-3.055 c0.123-0.308,0.123-27.487,0-81.535h94.635V153.985z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_70_",
    gradientUnits: "userSpaceOnUse",
    x1: 344.7251,
    y1: 670.6338,
    x2: 344.7251,
    y2: 668.643,
    gradientTransform: "matrix(7.472 0 0 -106.201 -1428.5908 71341.2188)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6BE9FF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#01F3FA"
    }
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_70_)",
    d: "M1141.25,80.593l11.896,6.796v162.277l-11.896-6.796V80.593z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_71_",
    gradientUnits: "userSpaceOnUse",
    x1: 346.2925,
    y1: 670.3789,
    x2: 346.2925,
    y2: 668.5774,
    gradientTransform: "matrix(7.472 0 0 -106.201 -1408.8174 71353.0938)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6BE9FF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#01F3FA"
    }
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_71_)",
    d: "M1172.729,99.447l11.896,6.796V268.52l-11.896-6.795V99.447z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_72_",
    gradientUnits: "userSpaceOnUse",
    x1: 347.8618,
    y1: 669.8428,
    x2: 347.8618,
    y2: 668.5119,
    gradientTransform: "matrix(7.473 0 0 -106.201 -1389.4617 71364.8516)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6BE9FF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#01F3FA"
    }
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_72_)",
    d: "M1204.169,118.139l11.898,6.796v162.277l-11.898-6.798V118.139z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_73_",
    gradientUnits: "userSpaceOnUse",
    x1: 437.0825,
    y1: 670.6299,
    x2: 437.0825,
    y2: 668.6391,
    gradientTransform: "matrix(-7.472 0 0 -106.201 4577.6846 71342.0313)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6BE9FF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#01F3FA"
    }
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_73_)",
    d: "M1317.753,81.854l-11.896,6.796v162.277l11.896-6.796V81.854z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_74_",
    gradientUnits: "userSpaceOnUse",
    x1: 438.6494,
    y1: 670.373,
    x2: 438.6494,
    y2: 668.5726,
    gradientTransform: "matrix(-7.472 0 0 -106.201 4557.9111 71353.8438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6BE9FF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#01F3FA"
    }
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_74_)",
    d: "M1286.271,100.708l-11.895,6.796v162.279l11.895-6.797V100.708z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_75_",
    gradientUnits: "userSpaceOnUse",
    x1: 440.2075,
    y1: 669.8398,
    x2: 440.2075,
    y2: 668.509,
    gradientTransform: "matrix(-7.473 0 0 -106.201 4538.5557 71365.6016)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6BE9FF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#01F3FA"
    }
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_75_)",
    d: "M1254.832,119.4l-11.896,6.796v162.277l11.896-6.798V119.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1190.625 249.06)",
    filter: "url(#ap)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_76_",
    gradientUnits: "userSpaceOnUse",
    x1: -834.1377,
    y1: 397.938,
    x2: -835.5173,
    y2: 398.3731,
    gradientTransform: "matrix(8.577 0 0 -4.951 7222.8638 1976.1787)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00C2FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B78FF"
    }
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_76_)",
    d: "M62.541,8.925l-6.827-3.94l6.827-3.941l6.828,3.941L62.541,8.925z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_77_",
    gradientUnits: "userSpaceOnUse",
    x1: -871.7842,
    y1: 403.231,
    x2: -874.1398,
    y2: 406.9507,
    gradientTransform: "matrix(4.289 0 0 -7.427 3813.3691 3017.1909)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00C2FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B78FF"
    }
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_77_)",
    d: "M69.369,4.984l-6.828-3.941v-7.882l6.828,3.942V4.984z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_78_",
    gradientUnits: "userSpaceOnUse",
    x1: -873.9414,
    y1: 406.9293,
    x2: -874.6842,
    y2: 405.8818,
    gradientTransform: "matrix(4.288 0 0 -7.427 3808.2842 3017.1909)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#188EFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1B37D6"
    }
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_78_)",
    d: "M62.541,1.043l-6.827,3.941v-7.882l6.827-3.942V1.043z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1199.39 219.843)",
    filter: "url(#at)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_79_",
    gradientUnits: "userSpaceOnUse",
    x1: -842.2982,
    y1: 430.6453,
    x2: -843.6767,
    y2: 431.08,
    gradientTransform: "matrix(8.577 0 0 -4.951 7298.042 2120.8342)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00C2FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B78FF"
    }
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_79_)",
    d: "M67.729-8.372l-6.827-3.94l6.827-3.942l6.828,3.942L67.729-8.372z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_80_",
    gradientUnits: "userSpaceOnUse",
    x1: -879.2948,
    y1: 434.7781,
    x2: -881.6506,
    y2: 438.4982,
    gradientTransform: "matrix(4.289 0 0 -7.427 3850.9604 3234.1838)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00C2FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B78FF"
    }
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_80_)",
    d: "M74.557-12.312l-6.828-3.942v-7.882l6.828,3.941V-12.312z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_81_",
    gradientUnits: "userSpaceOnUse",
    x1: -881.4901,
    y1: 438.4744,
    x2: -882.2321,
    y2: 437.4281,
    gradientTransform: "matrix(4.288 0 0 -7.427 3845.8687 3234.1838)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#188EFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1B37D6"
    }
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_81_)",
    d: "M67.729-16.254l-6.827,3.942v-7.882l6.827-3.941V-16.254z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-75 718.302 -664.667)",
    filter: "url(#au)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_82_",
    gradientUnits: "userSpaceOnUse",
    x1: -720.7214,
    y1: -633.5335,
    x2: -722.1003,
    y2: -633.0986,
    gradientTransform: "matrix(2.2199 4.7823 8.2847 -1.2814 6907.7876 2683.5667)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00C2FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B78FF"
    }
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_82_)",
    d: "M53.096,51.473l-6.827-3.941l6.826-3.941l6.828,3.94L53.096,51.473z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_83_",
    gradientUnits: "userSpaceOnUse",
    x1: -702.7424,
    y1: -657.266,
    x2: -705.0981,
    y2: -653.546,
    gradientTransform: "matrix(1.1101 7.1739 4.1429 -1.9222 3567.8218 3843.1077)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00C2FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B78FF"
    }
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_83_)",
    d: "M59.923,47.532l-6.828-3.94l0-7.882l6.829,3.94L59.923,47.532z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_84_",
    gradientUnits: "userSpaceOnUse",
    x1: -706.9263,
    y1: -658.4182,
    x2: -707.6683,
    y2: -659.4645,
    gradientTransform: "matrix(1.1098 7.1739 4.1419 -1.9222 3562.7559 3843.1077)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#188EFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1B37D6"
    }
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_84_)",
    d: "M53.096,43.591l-6.826,3.941l0-7.883l6.826-3.94L53.096,43.591z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-30 1032.226 -2165.775)",
    filter: "url(#av)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_85_",
    gradientUnits: "userSpaceOnUse",
    x1: -977.1752,
    y1: -34.263,
    x2: -978.5549,
    y2: -33.8279,
    gradientTransform: "matrix(7.4279 2.4755 4.2885 -4.2877 7492.3291 2303.9722)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00C2FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B78FF"
    }
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_85_)",
    d: "M81.184,34.946l-6.826-3.94l6.826-3.943l6.829,3.943L81.184,34.946z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_86_",
    gradientUnits: "userSpaceOnUse",
    x1: -1004.9341,
    y1: -58.7672,
    x2: -1007.2897,
    y2: -55.0475,
    gradientTransform: "matrix(3.7144 3.7135 2.1445 -6.432 3951.8137 3402.1943)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00C2FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B78FF"
    }
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_86_)",
    d: "M88.012,31.005l-6.829-3.943l0.001-7.881l6.828,3.942L88.012,31.005z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_87_",
    gradientUnits: "userSpaceOnUse",
    x1: -1008.6706,
    y1: -56.6597,
    x2: -1009.4129,
    y2: -57.7064,
    gradientTransform: "matrix(3.7135 3.7135 2.144 -6.432 3946.697 3402.198)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#188EFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1B37D6"
    }
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_87_)",
    d: "M81.183,27.062l-6.826,3.943l0-7.882l6.827-3.942L81.183,27.062z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-60 785.923 -901.186)",
    filter: "url(#aw)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_88_",
    gradientUnits: "userSpaceOnUse",
    x1: -828.8998,
    y1: -454.4756,
    x2: -830.2795,
    y2: -454.0406,
    gradientTransform: "matrix(4.2885 4.2877 7.4279 -2.4755 6982.332 2472.2627)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00C2FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B78FF"
    }
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_88_)",
    d: "M45.581,46.32l-6.826-3.94l6.826-3.942l6.828,3.942L45.581,46.32z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_89_",
    gradientUnits: "userSpaceOnUse",
    x1: -826.5209,
    y1: -489.0524,
    x2: -828.8765,
    y2: -485.3327,
    gradientTransform: "matrix(2.1445 6.432 3.7144 -3.7135 3646.6467 3560.3774)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00C2FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B78FF"
    }
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_89_)",
    d: "M52.408,42.38l-6.828-3.942l0-7.881l6.829,3.942L52.408,42.38z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_90_",
    gradientUnits: "userSpaceOnUse",
    x1: -830.9551,
    y1: -489.1096,
    x2: -831.6971,
    y2: -490.1559,
    gradientTransform: "matrix(2.144 6.432 3.7135 -3.7135 3641.5818 3560.3755)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#188EFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1B37D6"
    }
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_90_)",
    d: "M45.581,38.437l-6.826,3.942l0-7.882l6.826-3.941L45.581,38.437z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-105 678.265 -369.172)",
    filter: "url(#ax)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_91_",
    gradientUnits: "userSpaceOnUse",
    x1: -318.1607,
    y1: -927.3765,
    x2: -319.5403,
    y2: -927.8116,
    gradientTransform: "matrix(-2.2199 4.7823 8.2847 1.2814 7012.3096 2799.1882)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00C2FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B78FF"
    }
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_91_)",
    d: "M29.86,92.104l-6.826-3.94l6.827-3.942l6.828,3.942L29.86,92.104z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_92_",
    gradientUnits: "userSpaceOnUse",
    x1: -294.7456,
    y1: -918.0234,
    x2: -297.1011,
    y2: -921.7431,
    gradientTransform: "matrix(-1.1101 7.1739 4.1429 1.9222 3517.9966 3985.3572)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00C2FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B78FF"
    }
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_92_)",
    d: "M36.688,88.163l-6.828-3.942L29.86,76.34l6.828,3.942L36.688,88.163z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_93_",
    gradientUnits: "userSpaceOnUse",
    x1: -297.8956,
    y1: -921.175,
    x2: -298.6379,
    y2: -920.1283,
    gradientTransform: "matrix(-1.1098 7.1739 4.1419 1.9222 3512.8945 3985.3567)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#188EFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1B37D6"
    }
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_93_)",
    d: "M29.86,84.222l-6.827,3.942l-0.001-7.882l6.827-3.942L29.86,84.222z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_94_",
    gradientUnits: "userSpaceOnUse",
    x1: 388.9928,
    y1: 669.9667,
    x2: 391.1288,
    y2: 669.9667,
    gradientTransform: "matrix(75.5642 0 0 -107.8558 -28312.4043 72496.7109)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A22BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6374,
    style: {
      stopColor: "#0B0D7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A22BE"
    }
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_94_)",
    d: "M1227.358,172.766v124.893c0.09,0.414,0.063,0.866-0.103,1.28 c-0.134,0.355-0.383,0.655-0.706,0.854l-37.59,22.138c-1.915,1.153-4.311,1.153-6.227,0l-74.764-43.818 c-0.472-0.274-0.773-0.807-0.845-1.39h-0.016V151.087L1227.358,172.766z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B0F89",
    d: "M1120.48,266.294c0.641,0.314,1.051,0.967,1.051,1.684v10.602c0,0.345-0.28,0.625-0.625,0.625 c-0.095,0-0.189-0.021-0.275-0.065l-1.951-0.953c-0.644-0.313-1.051-0.967-1.051-1.682v-10.602c0-0.345,0.278-0.625,0.623-0.625 c0.095,0,0.19,0.021,0.275,0.065l1.953,0.953V266.294z M1114.445,262.973c0.643,0.314,1.05,0.967,1.05,1.682v10.602 c0.001,0.344-0.278,0.623-0.624,0.623c-0.095,0-0.189-0.021-0.275-0.062l-1.951-0.957c-0.643-0.314-1.051-0.965-1.051-1.681 V262.58c0-0.345,0.278-0.624,0.624-0.625c0.095,0,0.189,0.022,0.274,0.064L1114.445,262.973z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_95_",
    gradientUnits: "userSpaceOnUse",
    x1: 382.3009,
    y1: 669.8886,
    x2: 382.0937,
    y2: 670.1508,
    gradientTransform: "matrix(28.0622 0 0 -95.8328 -9525.4717 64435.1445)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F0856"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B0F89"
    }
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_95_)",
    d: "M1227.216,172.532v124.892c0.091,0.415,0.063,0.866-0.103,1.279 c-0.134,0.356-0.383,0.656-0.706,0.855l-37.589,22.141c-1.916,1.151-4.312,1.151-6.227,0V169.996L1227.216,172.532z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B0F89",
    d: "M1151.785,127.533l74.764,43.822c0.758,0.446,1.074,1.548,0.706,2.465 c-0.136,0.354-0.383,0.655-0.706,0.853l-37.59,22.142c-1.915,1.152-4.311,1.152-6.227,0l-74.764-43.82 c-0.759-0.446-1.076-1.548-0.708-2.465c0.136-0.354,0.385-0.655,0.708-0.853l37.59-22.142c1.915-1.152,4.311-1.152,6.227,0 V127.533z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_96_",
    gradientUnits: "userSpaceOnUse",
    x1: 390.8473,
    y1: 669.2119,
    x2: 388.6208,
    y2: 668.8468,
    gradientTransform: "matrix(72.758 0 0 -42.967 -27204.0352 28908.5547)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#188EFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1B37D6"
    }
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_96_)",
    d: "M1151.728,127.494l72.523,43.085c0.729,0.428,1.036,1.49,0.68,2.372 c-0.129,0.341-0.368,0.629-0.68,0.82l-34.728,20.465c-1.841,1.108-4.145,1.108-5.987,0l-73.461-42.558 c-0.729-0.428-1.035-1.49-0.681-2.373c0.145-0.356,0.384-0.646,0.681-0.819l35.662-20.992 C1147.581,126.385,1149.885,126.385,1151.728,127.494z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "#00BDFA",
    d: "M1146.721,140.742l-16.692,9.893c-0.123,0.08-0.216,0.197-0.266,0.335 c-0.165,0.407-0.025,0.896,0.266,1.066l53.866,31.57c1.198,0.725,2.7,0.726,3.9,0.003l16.694-9.895 c0.123-0.08,0.216-0.197,0.266-0.334c0.165-0.406,0.023-0.896-0.266-1.066l-53.866-31.57 C1149.425,140.019,1147.922,140.018,1146.721,140.742z M1205.069,171.323c0.806,0.471,1.121,1.572,0.752,2.485 c-0.152,0.382-0.415,0.7-0.747,0.896l-16.695,9.893c-1.559,0.936-3.507,0.936-5.066,0l-53.865-31.569 c-0.805-0.472-1.12-1.574-0.752-2.487c0.153-0.382,0.416-0.701,0.748-0.895l16.694-9.895c1.56-0.936,3.508-0.936,5.067,0 l53.865,31.57L1205.069,171.323z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_97_",
    gradientUnits: "userSpaceOnUse",
    x1: 384.2267,
    y1: 666.5576,
    x2: 382.84,
    y2: 666.4878,
    gradientTransform: "matrix(31.8292 0 0 -18.6986 -11037.0918 12625.459)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A22BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B0F89"
    }
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_97_)",
    d: "M1150.41,148.128l41.704,24.321c0.424,0.247,0.602,0.86,0.395,1.368 c-0.076,0.197-0.215,0.364-0.395,0.474l-4.53,2.642c-1.07,0.64-2.404,0.64-3.474,0l-41.708-24.324 c-0.423-0.247-0.601-0.86-0.396-1.368c0.076-0.197,0.215-0.365,0.396-0.475l4.53-2.642c1.069-0.64,2.405-0.64,3.475,0 L1150.41,148.128z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_98_",
    gradientUnits: "userSpaceOnUse",
    x1: 384.0831,
    y1: 666.3535,
    x2: 382.704,
    y2: 666.8038,
    gradientTransform: "matrix(31.8292 0 0 -18.6966 -11037.0918 12622.6338)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00C2FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B78FF"
    }
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_98_)",
    d: "M1150.41,145.746l41.704,24.321c0.424,0.247,0.602,0.86,0.395,1.37 c-0.076,0.197-0.215,0.362-0.395,0.473l-4.53,2.643c-1.07,0.639-2.404,0.639-3.474,0l-41.708-24.322 c-0.423-0.247-0.601-0.86-0.396-1.369c0.076-0.196,0.215-0.363,0.396-0.473v0.136v-0.136l4.53-2.643 c1.069-0.64,2.405-0.64,3.475,0H1150.41z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_99_",
    gradientUnits: "userSpaceOnUse",
    x1: 367.0426,
    y1: 657.9238,
    x2: 364.5698,
    y2: 657.7086,
    gradientTransform: "matrix(11.8243 0 0 -6.8691 -3114.3247 4700.2153)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A22BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B0F89"
    }
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_99_)",
    d: "M1208.051,176.863l1.593,0.806c0.156,0.092,0.222,0.319,0.146,0.509 c-0.027,0.074-0.08,0.137-0.147,0.178l-15.576,9.084c-0.4,0.239-0.899,0.239-1.299,0l-1.592-0.928 c-0.158-0.092-0.223-0.198-0.146-0.388c0.028-0.073,0.081-0.134,0.146-0.175l15.578-9.086 C1207.152,176.624,1207.651,176.624,1208.051,176.863z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_100_",
    gradientUnits: "userSpaceOnUse",
    x1: 392.7365,
    y1: 670.787,
    x2: 392.7078,
    y2: 669.2546,
    gradientTransform: "matrix(107.2394 0 0 -117.29 -40814.8516 78900.0469)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#02E8FD",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3049,
    style: {
      stopColor: "#02E5FD",
      stopOpacity: 0.385
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#01CCFB",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_101_",
    gradientUnits: "userSpaceOnUse",
    x1: 392.3375,
    y1: 670.6503,
    x2: 392.4424,
    y2: 669.554,
    gradientTransform: "matrix(107.2394 0 0 -117.29 -40814.8516 78900.0469)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#01E4FC",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2621,
    style: {
      stopColor: "#02EBFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9604,
    style: {
      stopColor: "#01E4FB",
      stopOpacity: 0.402
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#01E2FB",
      stopOpacity: 0
    }
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_100_)",
    stroke: "url(#SVGID_101_)",
    strokeWidth: 1.313,
    d: "M1232.487,215.731l-16.113,9.359l151.533,89.327 c1.579,0.939,2.096,2.98,1.154,4.56c-0.293,0.492-0.707,0.9-1.204,1.186l-124.687,71.381l16.156,9.471l116.602-66.754 c2.923-1.674,5.365-4.073,7.088-6.966c5.535-9.285,2.495-21.3-6.787-26.829L1232.487,215.731z"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1133.088 362.516)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00F6FF",
    d: "M56.772,47.35l-3.983-2.301l3.983-2.299l3.982,2.299L56.772,47.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#03E2F9",
    d: "M60.755,45.049l-3.982-2.296v-4.601l3.982,2.299V45.049z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#69E0FF",
    d: "M56.772,42.753l-3.983,2.297v-4.598l3.983-2.299V42.753z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1230.958 410.848)"
  }, _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.15,
    fill: "#03E1F9",
    enableBackground: "new    ",
    cx: -655.164,
    cy: -32.729,
    rx: 10.975,
    ry: 10.975
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#03E1F9",
    cx: -655.164,
    cy: -32.729,
    rx: 2.283,
    ry: 2.283
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.3,
    fill: "#03E1F9",
    enableBackground: "new    ",
    cx: -655.164,
    cy: -32.728,
    rx: 6.39,
    ry: 6.39
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_102_",
    gradientUnits: "userSpaceOnUse",
    x1: -1567.3685,
    y1: 259.2975,
    x2: -1567.3685,
    y2: 257.4156,
    gradientTransform: "matrix(1.445 0 0 -30.349 1609.6857 7790.3809)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#04F1FC",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03E1F9"
    }
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_102_)",
    d: "M-656.304-81.243h2.282v47.941h-2.282V-81.243z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1248.781 231.726)"
  }, _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.15,
    fill: "#03E1F9",
    enableBackground: "new    ",
    cx: 78.433,
    cy: 224.826,
    rx: 10.974,
    ry: 10.974
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#03E1F9",
    cx: 78.433,
    cy: 224.826,
    rx: 2.282,
    ry: 2.282
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.3,
    fill: "#03E1F9",
    enableBackground: "new    ",
    cx: 78.433,
    cy: 224.825,
    rx: 6.39,
    ry: 6.39
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_103_",
    gradientUnits: "userSpaceOnUse",
    x1: -1077.5118,
    y1: 429.9331,
    x2: -1077.5118,
    y2: 428.0512,
    gradientTransform: "matrix(1.445 0 0 -30.349 1635.4403 13226.5508)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#04F1FC",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03E1F9"
    }
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_103_)",
    d: "M77.293,176.311h2.283v47.941h-2.283V176.311z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1248.781 231.726)"
  }, _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.15,
    fill: "#03E1F9",
    enableBackground: "new    ",
    cx: -234.88,
    cy: -36.654,
    rx: 10.974,
    ry: 10.974
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#03E1F9",
    cx: -234.88,
    cy: -36.654,
    rx: 2.282,
    ry: 2.282
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.3,
    fill: "#03E1F9",
    enableBackground: "new    ",
    cx: -234.88,
    cy: -36.654,
    rx: 6.39,
    ry: 6.39
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_104_",
    gradientUnits: "userSpaceOnUse",
    x1: -1294.337,
    y1: 438.5483,
    x2: -1294.337,
    y2: 436.6676,
    gradientTransform: "matrix(1.445 0 0 -30.349 1635.4403 13226.5508)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#04F1FC",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03E1F9"
    }
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_104_)",
    d: "M-236.019-85.168h2.283v47.941h-2.283V-85.168z"
  }))), /*#__PURE__*/React.createElement("g", null, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#0D054C",
    enableBackground: "new    ",
    d: "M1073.332,371.749L1300.49,504.9 c2.304,1.35,3.267,4.703,2.147,7.49c-0.453,1.129-1.211,2.045-2.147,2.594l-227.158,133.152c-5.973,3.499-12.945,3.499-18.917,0 L827.258,514.984c-2.306-1.353-3.269-4.706-2.149-7.491c0.454-1.13,1.212-2.046,2.149-2.593l227.157-133.153 c5.972-3.501,12.944-3.501,18.917,0V371.749z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#22FCFF",
    strokeWidth: 0.5,
    d: "M1071.683,395.517l187.515,110.251c1.901,1.119,2.697,3.895,1.772,6.202 c-0.376,0.937-1,1.692-1.772,2.146l-187.515,110.25c-4.931,2.9-10.688,2.9-15.617,0L868.551,514.116 c-1.903-1.12-2.699-3.896-1.774-6.2c0.376-0.938,1-1.692,1.774-2.148l187.515-110.251 C1060.995,392.621,1066.752,392.621,1071.683,395.517L1071.683,395.517z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B0F89",
    d: "M1027.419,255.852c1.482-1.06,2.31-1.624,2.488-1.692c1.223-0.465,2.791-0.1,4.504,0.898l170.069,99.12 c4.7,2.78,7.063,6.326,7.063,13.63v140.523c0,3.489-0.951,5.455-2.454,6.144l-1.338,0.767 C1208.554,514.654,1148.442,428.191,1027.419,255.852z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B0F89",
    d: "M1211.544,379.251v133.383l-1.526,1.082V380.334l1.526-1.079V379.251z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_105_",
    gradientUnits: "userSpaceOnUse",
    x1: 392.1827,
    y1: 670.7363,
    x2: 389.0886,
    y2: 667.4125,
    gradientTransform: "matrix(105.522 0 0 -151.4895 -40192.5664 101884.0859)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#486BD7"
    }
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_105_)",
    d: "M1202.955,518.783l-170.001-99.103c-4.265-2.475-7.063-5.141-7.063-13.626V261.977 c0-6.658,3.162-7.665,7.063-5.392l170.001,99.103c4.7,2.777,7.063,6.325,7.063,13.626v144.078c0,6.365-3.161,7.664-7.063,5.393 V518.783z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_106_",
    gradientUnits: "userSpaceOnUse",
    x1: 392.131,
    y1: 670.7304,
    x2: 389.0773,
    y2: 667.4055,
    gradientTransform: "matrix(104.208 0 0 -150.6133 -39673.3203 101296.2266)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#486BD7"
    }
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_106_)",
    d: "M1203.556,356.901c3.14,1.841,5.698,6.313,5.698,9.971v148.101c0,3.655-2.554,5.136-5.698,3.297 l-170.439-99.861c-3.142-1.839-5.697-6.313-5.697-9.971V260.339c0-3.658,2.556-5.138,5.697-3.297L1203.556,356.901z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B0F89",
    d: "M1201.615,364.777v145.114l-169.612-98.595V266.182L1201.615,364.777z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_107_",
    gradientUnits: "userSpaceOnUse",
    x1: 391.5094,
    y1: 671.0175,
    x2: 390.6727,
    y2: 668.9064,
    gradientTransform: "matrix(93.699 0 0 -130.821 -35523.0781 88016.0625)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#188EFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1B37D6"
    }
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_107_)",
    d: "M1198.558,376.425v124.722c-0.001,0.844-0.687,1.529-1.529,1.526c-0.27,0-0.534-0.068-0.768-0.206 l-159.305-92.74c-1.174-0.686-1.896-1.943-1.896-3.303V275.929c0-0.845,0.688-1.528,1.531-1.526c0.269,0,0.532,0.071,0.765,0.206 l32.345,18.83c0.511,0.296,0.945,0.709,1.27,1.2l5.675,8.615l120.015,69.868c1.176,0.685,1.898,1.94,1.898,3.301V376.425z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "#1830BA",
    d: "M1154.326,427.477v12.373c-0.002,0.641-0.521,1.161-1.163,1.159c-0.205-0.001-0.408-0.056-0.585-0.158 l-33.561-19.462c-0.894-0.518-1.445-1.474-1.445-2.506v-12.371c0-0.645,0.521-1.162,1.164-1.162c0.203,0,0.407,0.056,0.584,0.159 l33.56,19.46C1153.776,425.489,1154.326,426.445,1154.326,427.477L1154.326,427.477z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B0F89",
    d: "M1122.879,421.172v-9.118l4.047,2.334c0.998,0.577,1.784,1.313,2.281,2.122 c0.398,0.646,0.599,1.27,0.599,1.896v0.024c0,1.03-0.523,1.301-1.146,1.307c1.011,0.986,1.633,1.958,1.633,3.182v0.024 c0,1.671-1.297,1.756-3.265,0.62L1122.879,421.172L1122.879,421.172z M1124.744,416.816l1.772,1.021 c0.847,0.488,1.383,0.509,1.383-0.168v-0.027c0-0.598-0.446-1.194-1.26-1.662l-1.894-1.091v1.927H1124.744z M1124.744,420.492 l2.283,1.312c0.846,0.491,1.356,0.472,1.356-0.206v-0.024c0-0.613-0.436-1.242-1.42-1.812l-2.218-1.277v2.008H1124.744z  M1135.512,428.597c-2.343-1.35-3.775-3.542-3.775-6.227v-5.21l1.92,1.106v5.157c0,1.485,0.711,2.664,1.882,3.339 c1.172,0.673,1.883,0.341,1.883-1.104v-5.223l1.918,1.104v5.146C1139.339,429.446,1137.858,429.946,1135.512,428.597z  M1143.749,433.2v-3.593l-3.35-7.455l2.24,1.291l2.081,4.859l2.12-2.439l2.181,1.258l-3.353,3.551v3.632L1143.749,433.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_108_",
    gradientUnits: "userSpaceOnUse",
    x1: 382.8219,
    y1: 666.707,
    x2: 378.0176,
    y2: 663.3796,
    gradientTransform: "matrix(27.254 0 0 -31.415 -9263.2705 21320.7598)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#486BD7"
    }
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_108_)",
    d: "M1117.572,383.623v-4.412l47.557,27.401l-0.015,4.409L1117.572,383.623z M1165.08,422.214 l-0.012,4.404l-29.769-17.152l0.014-4.409l29.767,17.153V422.214z M1160.867,411.709v4.414l-43.295-24.946v-4.414L1160.867,411.709 z M1160.867,401.021l-25.501-14.694l0.013-4.405l25.488,14.685V401.021z M1117.572,376.194v-4.393l13.588,7.638l-0.014,4.386 L1117.572,376.194z M1117.572,399.264v-4.393l13.517,7.597l-0.012,4.389l-13.505-7.59V399.264z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_109_",
    gradientUnits: "userSpaceOnUse",
    x1: 383.8751,
    y1: 665.0751,
    x2: 385.6203,
    y2: 664.8268,
    gradientTransform: "matrix(34.963 0 0 -24.698 -12304.4697 16802.2715)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A22BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B0F89"
    }
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_109_)",
    d: "M1117.572,365.774v-7.952l61.008,35.15l-0.018,7.943L1117.572,365.774z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B0F89",
    d: "M1195.501,386.347c0,2.411-1.974,4.366-4.407,4.366c-0.778,0-1.542-0.204-2.217-0.594l-144.14-82.961 c-4.09-2.341-6.616-6.688-6.624-11.399c0-2.409,1.974-4.363,4.409-4.363c0.775,0,1.541,0.205,2.215,0.591l144.14,82.964 C1192.967,377.289,1195.492,381.638,1195.501,386.347z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_110_",
    gradientUnits: "userSpaceOnUse",
    x1: 335.7179,
    y1: 650.7275,
    x2: 334.6416,
    y2: 648.6172,
    gradientTransform: "matrix(5.692 0 0 -7.0054 -719.8348 4932.2461)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#188EFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1B37D6"
    }
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_110_)",
    d: "M1187.479,387.72c2.741,1.569,4.965,0.416,4.965-2.572c0-2.989-2.224-6.684-4.965-8.251 c-2.744-1.568-4.967-0.416-4.967,2.574C1182.512,382.458,1184.734,386.151,1187.479,387.72z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_111_",
    gradientUnits: "userSpaceOnUse",
    x1: 285.1329,
    y1: 622.541,
    x2: 278.7542,
    y2: 619.2166,
    gradientTransform: "matrix(3.0645 0 0 -3.0643 318.0306 2287.5349)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#486BD7"
    }
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_111_)",
    d: "M1185.935,382.025c-0.531-1.202-0.422-2.327,0.337-2.67c0.887-0.404,2.329,0.421,3.215,1.84 c0.89,1.419,0.89,2.898,0,3.302c-0.758,0.344-1.916-0.204-2.79-1.251l-0.973,0.441c-0.211,0.097-0.553-0.1-0.76-0.436 c-0.21-0.338-0.21-0.687,0-0.784L1185.935,382.025z M1186.812,382.411c0.59,0.941,1.543,1.488,2.133,1.22 c0.587-0.268,0.587-1.248,0-2.188c-0.59-0.944-1.543-1.487-2.133-1.221C1186.224,380.488,1186.224,381.47,1186.812,382.411z"
  })), /*#__PURE__*/React.createElement("g", null, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "#1830BA",
    d: "M1116.043,358.627v87.574c0,1.419-1.149,2.571-2.571,2.571c-0.451,0-0.896-0.119-1.287-0.346 l-68.585-39.931c-1.979-1.154-3.195-3.271-3.195-5.562V315.36c0-1.421,1.151-2.571,2.571-2.572c0.453,0,0.897,0.118,1.289,0.347 l68.586,39.931C1114.829,354.219,1116.043,356.336,1116.043,358.627L1116.043,358.627z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B0F89",
    d: "M1112.28,422.119c-0.003,1.28-1.04,2.315-2.318,2.313c-0.404,0-0.804-0.106-1.156-0.311l-61.761-35.957 c-1.781-1.038-2.875-2.946-2.875-5.009V321.87c0.002-1.277,1.038-2.314,2.317-2.314c0.406,0,0.804,0.109,1.156,0.31l61.76,35.959 c1.782,1.04,2.877,2.947,2.877,5.008V422.119z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_112_",
    gradientUnits: "userSpaceOnUse",
    x1: 369.9122,
    y1: 665.6064,
    x2: 369.1343,
    y2: 663.4936,
    gradientTransform: "matrix(15.2616 0 0 -22.1061 -4562.4487 15058.9072)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#188EFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1B37D6"
    }
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_112_)",
    d: "M1074.341,384.958c-1.782-1.038-3.227-3.49-3.227-5.479c0-1.986,1.444-2.758,3.227-1.716 c1.782,1.038,3.228,3.492,3.228,5.478C1077.568,385.228,1076.123,385.997,1074.341,384.958z M1084.684,383.754 c1.548,1.071,2.77,3.147,2.924,4.965c0.175,2.1-1.135,3.112-2.924,2.267c-0.223-0.105-0.438-0.231-0.64-0.372 c-1.791-1.24-3.1-3.783-2.925-5.678C1081.297,383.044,1082.892,382.516,1084.684,383.754z M1091.327,373.934 c0.186,0.348,0.256,0.716,0.188,0.984l-2.319,8.985c-0.102,0.41-0.476,0.524-0.907,0.274l-16.393-9.55 c-0.444-0.254-0.83-0.833-0.906-1.369l-2.913-16.609l-3.166-1.846v-2.094l3.914,2.28c0.434,0.255,0.809,0.807,0.911,1.333 l0.907,5.142l2.666,1.552v-0.07c0-4.225,3.071-5.86,6.861-3.651c3.79,2.211,6.864,7.425,6.864,11.649v0.07l3.571,2.081 C1090.896,373.257,1091.165,373.574,1091.327,373.934z M1080.17,372.496c2.745,1.582,4.965,0.402,4.983-2.647 c0-3.067-2.23-6.854-4.983-8.457c-2.752-1.604-4.982-0.418-4.982,2.651C1075.188,367.108,1077.418,370.894,1080.17,372.496z  M1079.419,366.611l3.289-1.541l1.287,2.286l-3.949,1.855c-0.176,0.091-0.413,0.053-0.66-0.104 c-0.271-0.175-0.498-0.414-0.657-0.697l-2.38-4.077l1.346-0.68L1079.419,366.611z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "#1830BA",
    d: "M1154.324,449.511v20.772c0,0.643-0.521,1.163-1.161,1.163c-0.208,0-0.408-0.056-0.585-0.159 l-33.561-19.462c-0.895-0.516-1.447-1.473-1.447-2.507v-20.772c0-0.646,0.52-1.163,1.162-1.163c0.206,0,0.407,0.056,0.587,0.156 l33.559,19.462c0.895,0.521,1.448,1.475,1.448,2.51H1154.324z M1193.21,471.914v20.775c0,0.641-0.521,1.162-1.163,1.162 c-0.206,0-0.409-0.055-0.587-0.159l-33.559-19.46c-0.895-0.518-1.446-1.474-1.446-2.508v-20.775c0-0.641,0.521-1.16,1.161-1.158 c0.208,0,0.407,0.055,0.587,0.158l33.559,19.458c0.895,0.521,1.448,1.477,1.448,2.511V471.914z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B0F89",
    d: "M1134.658,457.102c-0.005,0.277-0.233,0.499-0.511,0.496c-0.091,0.002-0.182-0.022-0.259-0.067 l-13.667-7.975c-0.39-0.214-0.634-0.623-0.637-1.07v-16.88c0-0.275,0.229-0.497,0.511-0.497c0.09,0,0.181,0.024,0.26,0.067 l13.666,7.974c0.39,0.217,0.633,0.626,0.637,1.071V457.102z M1173.77,479.855c-0.006,0.277-0.233,0.498-0.512,0.496 c-0.09,0-0.18-0.022-0.259-0.066l-13.666-7.976c-0.391-0.214-0.634-0.625-0.638-1.069v-16.883c0-0.272,0.229-0.493,0.512-0.493 c0.09,0,0.181,0.021,0.259,0.063l13.667,7.975c0.39,0.218,0.633,0.627,0.637,1.072V479.855z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "#01E5FB",
    d: "M1180.003,474.906c-1.649-0.951-2.75-3.043-2.75-4.827v-0.035c0-1.786,1.082-2.635,2.765-1.667 c1.665,0.959,2.751,3.061,2.751,4.83v0.035C1182.769,475.027,1181.652,475.858,1180.003,474.906L1180.003,474.906z  M1187.154,484.977c-1.651-0.952-2.75-3.059-2.75-4.829v-0.034c0-1.785,1.085-2.637,2.766-1.664 c1.665,0.959,2.75,3.043,2.75,4.827v0.035C1189.92,485.082,1188.802,485.931,1187.154,484.977z M1180.018,473.007 c0.521,0.3,0.886-0.061,0.886-0.823v-0.035c0-0.762-0.379-1.57-0.899-1.872c-0.536-0.309-0.888,0.062-0.888,0.825v0.033 c0,0.781,0.399,1.583,0.904,1.873L1180.018,473.007z M1187.17,483.077c0.519,0.303,0.887-0.059,0.887-0.822v-0.034 c0-0.78-0.384-1.572-0.902-1.872c-0.55-0.317-0.887,0.043-0.887,0.821v0.036C1186.268,481.968,1186.666,482.788,1187.17,483.077z  M1182.938,475.835l3.742-3.442l2.065,1.19l-4.603,4.022l-3.651,3.355l-2.062-1.188L1182.938,475.835L1182.938,475.835z"
  }))), /*#__PURE__*/React.createElement("g", null, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#01E5FB",
    strokeWidth: 2.189,
    strokeLinecap: "round",
    d: "M1006.861,393.975l-36.745,21.079v-10.859 c0.001-13.103,7.01-25.202,18.374-31.721c5.879-3.368,13.375-1.335,16.746,4.543c1.064,1.856,1.625,3.958,1.625,6.1V393.975z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_113_",
    gradientUnits: "userSpaceOnUse",
    x1: 384.0812,
    y1: 664.4697,
    x2: 385.8262,
    y2: 664.3077,
    gradientTransform: "matrix(42.179 0 0 -24.066 -15242.8398 16391.207)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A22BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B0F89"
    }
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_113_)",
    d: "M971.36,423.072l-13.727-6.833l60.024-35.162l4.536,5.208l9.038,2.107L971.36,423.072z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_114_",
    gradientUnits: "userSpaceOnUse",
    x1: 384.879,
    y1: 669.413,
    x2: 384.257,
    y2: 667.3029,
    gradientTransform: "matrix(40.028 0 0 -64.801 -14386.3945 43748.9258)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#188EFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1B37D6"
    }
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_114_)",
    d: "M971.36,423.072l2.878,78.392l66.966-38.549l-9.972-74.522L971.36,423.072z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#01E5FB",
    strokeWidth: 2.189,
    strokeLinecap: "round",
    d: "M984.633,423.453v-10.855 c0-13.103,7.011-25.201,18.373-31.72c5.879-3.371,13.376-1.339,16.747,4.538c1.065,1.857,1.627,3.963,1.627,6.104v10.858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_115_",
    gradientUnits: "userSpaceOnUse",
    x1: 314.9449,
    y1: 668.207,
    x2: 314.9236,
    y2: 666.0967,
    gradientTransform: "matrix(5.421 0 0 -47.323 -737.7059 32029.9551)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#188EFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1B37D6"
    }
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_115_)",
    d: "M971.36,423.072l2.878,78.392l-9.459-19.06l1.5-63.514L971.36,423.072z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_116_",
    gradientUnits: "userSpaceOnUse",
    x1: 357.3287,
    y1: 667.5859,
    x2: 357.4388,
    y2: 665.5494,
    gradientTransform: "matrix(11.695 0 0 -39.302 -3223.6318 26642.3223)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#188EFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1B37D6"
    }
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_116_)",
    d: "M957.483,416.239l-11.609,68.578l18.906-2.413l1.5-63.514L957.483,416.239z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_117_",
    gradientUnits: "userSpaceOnUse",
    x1: 369.4552,
    y1: 653.5312,
    x2: 367.8234,
    y2: 652.5881,
    gradientTransform: "matrix(16.322 0 0 -10.906 -5049.0615 7612.3433)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#188EFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1B37D6"
    }
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_117_)",
    d: "M974.219,501.435l-28.48-16.638l19.041-2.393L974.219,501.435z"
  })), /*#__PURE__*/React.createElement("g", null, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#01E5FB",
    strokeWidth: 2.189,
    strokeLinecap: "round",
    d: "M1026.188,437.053l-27.704,15.778v-8.128 c0-9.806,5.282-18.862,13.852-23.743c1.402-0.799,2.989-1.218,4.601-1.218c5.11,0,9.252,4.111,9.252,9.186V437.053z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_118_",
    gradientUnits: "userSpaceOnUse",
    x1: 381.1056,
    y1: 661.2734,
    x2: 382.8504,
    y2: 661.1138,
    gradientTransform: "matrix(31.802 0 0 -18.014 -11131.0957 12353.8369)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A22BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B0F89"
    }
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_118_)",
    d: "M999.418,458.834l-10.349-5.118l45.258-26.315l3.42,3.897l6.813,1.577L999.418,458.834z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_119_",
    gradientUnits: "userSpaceOnUse",
    x1: 381.7491,
    y1: 668.2324,
    x2: 381.1174,
    y2: 666.1199,
    gradientTransform: "matrix(30.18 0 0 -48.506 -10485.2783 32832.3672)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#188EFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1B37D6"
    }
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_119_)",
    d: "M999.418,458.834l2.172,58.68l50.492-28.854l-7.521-55.784L999.418,458.834z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#01E5FB",
    strokeWidth: 2.189,
    strokeLinecap: "round",
    d: "M1009.427,459.12v-8.127 c0-9.804,5.285-18.862,13.855-23.743c1.4-0.797,2.986-1.217,4.6-1.217c5.108,0,9.248,4.11,9.248,9.184v8.126"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_120_",
    gradientUnits: "userSpaceOnUse",
    x1: 291.8121,
    y1: 666.5839,
    x2: 291.7904,
    y2: 664.4716,
    gradientTransform: "matrix(4.088 0 0 -35.424 -194.8293 24060.8672)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#188EFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1B37D6"
    }
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_120_)",
    d: "M999.418,458.834l2.172,58.68l-7.134-14.268l1.133-47.544L999.418,458.834z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_121_",
    gradientUnits: "userSpaceOnUse",
    x1: 346.5973,
    y1: 665.6308,
    x2: 346.709,
    y2: 663.5938,
    gradientTransform: "matrix(8.818 0 0 -29.42 -2068.9829 20028.0586)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#188EFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1B37D6"
    }
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_121_)",
    d: "M988.956,453.716l-8.754,51.338l14.254-1.808l1.133-47.544L988.956,453.716z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_122_",
    gradientUnits: "userSpaceOnUse",
    x1: 361.7682,
    y1: 646.4765,
    x2: 360.136,
    y2: 645.5467,
    gradientTransform: "matrix(12.306 0 0 -8.164 -3445.0625 5783.0405)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#188EFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1B37D6"
    }
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_122_)",
    d: "M1001.574,517.492l-21.473-12.454l14.354-1.792L1001.574,517.492z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_123_",
    gradientUnits: "userSpaceOnUse",
    x1: 385.1378,
    y1: 663.0117,
    x2: 383.626,
    y2: 663.4885,
    gradientTransform: "matrix(42.511 0 0 -24.542 -15409.127 16752.7012)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00C2FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B78FF"
    }
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_123_)",
    d: "M933.095,454.121l37.09,21.412l-37.09,21.411l-37.088-21.411L933.095,454.121z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fill: "#141BAA",
    enableBackground: "new    ",
    d: "M947.612,462.525l7.925,4.575l-37.091,21.41l-7.924-4.574 L947.612,462.525z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_124_",
    gradientUnits: "userSpaceOnUse",
    x1: 384.1549,
    y1: 665.9745,
    x2: 384.7366,
    y2: 665.477,
    gradientTransform: "matrix(42.511 0 0 -36.813 -15409.127 25004.959)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A22BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B0F89"
    }
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_124_)",
    d: "M970.215,475.561v42.824l-37.088,21.412v-42.823L970.215,475.561z M933.127,496.975v42.823 l-37.09-21.412v-42.824L933.127,496.975z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B0F89",
    d: "M918.423,488.475v12.265l-7.9-4.557v-12.267L918.423,488.475z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_125_",
    gradientUnits: "userSpaceOnUse",
    x1: 385.6281,
    y1: 662.5068,
    x2: 384.1162,
    y2: 662.9836,
    gradientTransform: "matrix(42.511 0 0 -24.542 -15381.0957 16769.3418)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00C2FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B78FF"
    }
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_125_)",
    d: "M981.993,483.152l37.09,21.413l-37.09,21.411l-37.088-21.411L981.993,483.152z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fill: "#141BAA",
    enableBackground: "new    ",
    d: "M996.513,491.556l7.923,4.576l-37.093,21.411l-7.923-4.573 L996.513,491.556z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_126_",
    gradientUnits: "userSpaceOnUse",
    x1: 384.6456,
    y1: 665.6376,
    x2: 385.2273,
    y2: 665.1401,
    gradientTransform: "matrix(42.511 0 0 -36.813 -15381.0957 25021.6152)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A22BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B0F89"
    }
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_126_)",
    d: "M1019.112,504.594v42.823l-37.089,21.412v-42.824L1019.112,504.594z M982.024,526.005v42.824 l-37.089-21.412v-42.823L982.024,526.005z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B0F89",
    d: "M967.319,517.506v12.268l-7.899-4.559v-12.267L967.319,517.506z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_127_",
    gradientUnits: "userSpaceOnUse",
    x1: 344.5548,
    y1: 651.3915,
    x2: 344.7516,
    y2: 652.5001,
    gradientTransform: "matrix(7.99 0 0 -12.0269 -1709.3527 8407.5176)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#131AA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#090C62"
    }
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_127_)",
    d: "M1039.996,575.1c-1.367-0.819-2.238-2.767-2.238-5.519c0-4.863,2.721-10.392,6.082-12.346 c1.568-0.914,2.999-0.885,4.077-0.099l3.783,2.203l-1.876,4.794c-0.514,4.409-2.998,8.975-5.984,10.714 c-0.082,0.046-0.167,0.092-0.25,0.137l0.571,2.551l-4.166-2.431L1039.996,575.1L1039.996,575.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_128_",
    gradientUnits: "userSpaceOnUse",
    x1: 337.0411,
    y1: 650.1786,
    x2: 337.7569,
    y2: 649.6812,
    gradientTransform: "matrix(6.969 0 0 -10.8816 -1304.236 7639.8125)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A22BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B0F89"
    }
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_128_)",
    d: "M1047.908,577.229c3.359-1.952,6.08-7.48,6.08-12.343c0-4.864-2.721-7.223-6.08-5.268 c-3.356,1.954-6.079,7.481-6.079,12.347c0,4.866,2.72,7.221,6.079,5.267V577.229z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00BDFA",
    strokeWidth: 0.657,
    d: "M1047.622,573.571c1.96-1.142,3.61-4.49,3.61-7.415 c0-2.724-1.325-3.874-3.036-2.879c-1.962,1.142-3.61,4.49-3.61,7.417C1044.586,573.419,1045.911,574.566,1047.622,573.571z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_129_",
    gradientUnits: "userSpaceOnUse",
    x1: 346.545,
    y1: 652.0429,
    x2: 346.7419,
    y2: 653.1515,
    gradientTransform: "matrix(7.99 0 0 -12.0269 -1688.005 8397.002)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#131AA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#090C62"
    }
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_129_)",
    d: "M1077.247,556.745c-1.367-0.82-2.239-2.767-2.239-5.519c0-4.862,2.723-10.391,6.081-12.346 c1.571-0.915,3.001-0.884,4.078-0.098l3.782,2.202l-1.875,4.794c-0.514,4.41-2.998,8.973-5.985,10.713 c-0.082,0.047-0.164,0.094-0.248,0.137l0.569,2.551l-4.166-2.429v-0.006H1077.247z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_130_",
    gradientUnits: "userSpaceOnUse",
    x1: 339.3224,
    y1: 650.8974,
    x2: 340.0382,
    y2: 650.3999,
    gradientTransform: "matrix(6.969 0 0 -10.8816 -1282.8883 7629.2969)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A22BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B0F89"
    }
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_130_)",
    d: "M1085.16,558.877c3.357-1.956,6.078-7.483,6.078-12.347s-2.721-7.22-6.078-5.266 c-3.358,1.955-6.082,7.482-6.082,12.348S1081.802,560.833,1085.16,558.877L1085.16,558.877z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00BDFA",
    strokeWidth: 0.657,
    d: "M1084.871,555.217c1.962-1.142,3.612-4.489,3.612-7.415 c0-2.725-1.326-3.876-3.035-2.88c-1.961,1.144-3.612,4.491-3.612,7.416C1081.836,555.064,1083.161,556.211,1084.871,555.217z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_131_",
    gradientUnits: "userSpaceOnUse",
    x1: 389.755,
    y1: 669.747,
    x2: 388.8253,
    y2: 667.6365,
    gradientTransform: "matrix(64.646 0 0 -85.6105 -24058.0781 57752.168)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#188EFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1B37D6"
    }
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_131_)",
    d: "M1133.757,562.327l-50.815,26.474c-2.084,1.087-4.578,1.032-6.615-0.142l-33.012-19.058 c-2.611-1.508-2.53-5.303,0.145-6.697l51.198-26.669c2.082-1.088,4.575-1.034,6.61,0.143l28.62,16.521l16.415-80.632 c1.123-5.512-1.431-11.121-6.325-13.894l-17.563-9.94c-2.2-1.248-4.998-0.474-6.246,1.73c-0.243,0.43-0.416,0.896-0.511,1.38 l-4.856,24.83c-0.464,2.061-2.507,3.356-4.567,2.895c-1.978-0.444-3.267-2.358-2.933-4.359l4.858-24.835 c1.297-6.624,7.72-10.944,14.346-9.647c1.29,0.252,2.53,0.712,3.674,1.36l17.562,9.938c7.776,4.402,11.833,13.311,10.052,22.068 l-17.44,85.655C1136.072,560.809,1135.081,561.909,1133.757,562.327L1133.757,562.327z M1053.164,566.465l26.62,15.368 l44.65-23.261l-26.621-15.37l-44.652,23.26L1053.164,566.465z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_132_",
    gradientUnits: "userSpaceOnUse",
    x1: 380.7057,
    y1: 666.0244,
    x2: 381.5549,
    y2: 665.5267,
    gradientTransform: "matrix(26.904 0 0 -38.567 -9137.5527 26180.9883)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A22BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B0F89"
    }
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_132_)",
    d: "M1103.471,472.457l-7.475,46.598l41.48,20.699l5.466-45.601L1103.471,472.457z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_133_",
    gradientUnits: "userSpaceOnUse",
    x1: 387.005,
    y1: 663.9286,
    x2: 388.7497,
    y2: 663.7646,
    gradientTransform: "matrix(53.576 0 0 -30.76 -19687.9238 20964.2402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A22BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B0F89"
    }
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_133_)",
    d: "M1097.025,517.211l43.157,23.877l-61.516,29.796l-31.972-26.836L1097.025,517.211z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_134_",
    gradientUnits: "userSpaceOnUse",
    x1: 385.4957,
    y1: 666.416,
    x2: 387.2235,
    y2: 665.9184,
    gradientTransform: "matrix(43.662 0 0 -43.8807 -15763.1953 29760.7754)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A22BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B0F89"
    }
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_134_)",
    d: "M1146.681,492.752l-8.141,46.808l-55.529,29.146c-2.613,1.373-5.848,0.364-7.22-2.249 c-0.275-0.525-0.461-1.091-0.552-1.677l-4.746-30.956l76.188-41.073V492.752z M1096.824,527.284 c-1.652,0.859-3.318,3.07-3.724,4.933l-5.851,26.987c-0.405,1.861,0.607,2.675,2.261,1.812c1.65-0.859,3.316-3.069,3.723-4.933 l5.852-26.986c0.404-1.862-0.608-2.674-2.261-1.815V527.284z M1113.137,518.777c-1.653,0.861-3.319,3.072-3.726,4.935 l-5.852,26.988c-0.403,1.861,0.608,2.672,2.262,1.812s3.318-3.071,3.724-4.934l5.854-26.987 C1115.8,518.729,1114.788,517.919,1113.137,518.777z M1129.2,510.401c-1.652,0.862-3.321,3.073-3.725,4.935l-5.852,26.987 c-0.406,1.861,0.606,2.675,2.26,1.813c1.652-0.862,3.321-3.069,3.723-4.933l5.854-26.986 C1131.863,510.353,1130.852,509.541,1129.2,510.401z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_135_",
    gradientUnits: "userSpaceOnUse",
    x1: 387.1481,
    y1: 665.6103,
    x2: 385.7574,
    y2: 667.0411,
    gradientTransform: "matrix(43.662 0 0 -45.525 -15761.8848 30865.8164)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00C2FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B78FF"
    }
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_135_)",
    d: "M1148.971,494.281l-8.136,46.805l-62.169,32.63l-5.881-38.365L1148.971,494.281 L1148.971,494.281z M1099.117,528.812c-1.652,0.859-3.321,3.071-3.723,4.932l-5.853,26.986c-0.405,1.863,0.605,2.675,2.259,1.814 c1.652-0.86,3.321-3.07,3.723-4.934l5.854-26.988c0.405-1.86-0.605-2.673-2.26-1.813V528.812z M1115.429,520.306 c-1.653,0.862-3.319,3.072-3.724,4.933l-5.854,26.988c-0.403,1.863,0.608,2.674,2.26,1.813c1.653-0.859,3.32-3.071,3.726-4.933 l5.852-26.988c0.405-1.863-0.607-2.674-2.26-1.812V520.306z M1131.49,511.93c-1.652,0.861-3.319,3.073-3.724,4.935l-5.853,26.986 c-0.401,1.863,0.61,2.675,2.263,1.813c1.651-0.862,3.318-3.069,3.723-4.935l5.854-26.986 C1134.156,511.882,1133.145,511.067,1131.49,511.93z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_136_",
    gradientUnits: "userSpaceOnUse",
    x1: 384.6593,
    y1: 666.6152,
    x2: 386.2171,
    y2: 666.1177,
    gradientTransform: "matrix(41.368 0 0 -43.78 -14881.4619 29680.6406)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A22BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B0F89"
    }
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_136_)",
    d: "M1102.126,470.879l-8.139,46.042l-57.822,30.349l-6.223-38.202L1102.126,470.879z  M1052.271,504.645c-1.65,0.861-3.317,3.07-3.723,4.933l-5.853,26.988c-0.404,1.862,0.609,2.675,2.262,1.813 c1.652-0.861,3.32-3.069,3.724-4.934l5.851-26.987C1054.935,504.595,1053.923,503.783,1052.271,504.645z M1068.583,496.141 c-1.653,0.863-3.321,3.07-3.723,4.933l-5.854,26.989c-0.404,1.863,0.608,2.676,2.26,1.814c1.653-0.864,3.32-3.071,3.723-4.935 l5.854-26.987C1071.247,496.091,1070.236,495.279,1068.583,496.141z M1084.646,487.766c-1.653,0.861-3.32,3.071-3.724,4.933 l-5.853,26.988c-0.404,1.865,0.606,2.675,2.261,1.815c1.652-0.862,3.319-3.071,3.723-4.936l5.854-26.986 C1087.309,487.718,1086.297,486.904,1084.646,487.766L1084.646,487.766z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_137_",
    gradientUnits: "userSpaceOnUse",
    x1: 386.6989,
    y1: 665.6835,
    x2: 385.2206,
    y2: 667.1143,
    gradientTransform: "matrix(43.38 0 0 -43.8684 -15676.2598 29740.1074)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00C2FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B78FF"
    }
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_137_)",
    d: "M1103.779,471.143l-6.658,46.068l-56.508,29.859c-2.613,1.379-5.846,0.381-7.227-2.232 c-0.278-0.527-0.467-1.098-0.558-1.688l-4.743-30.938l75.693-41.067V471.143z M1054.417,505.674 c-1.652,0.863-3.319,3.071-3.724,4.935l-5.853,26.985c-0.401,1.865,0.61,2.676,2.262,1.815c1.652-0.862,3.319-3.07,3.725-4.935 l5.85-26.985c0.406-1.86-0.606-2.675-2.26-1.813V505.674z M1070.729,497.17c-1.65,0.861-3.319,3.071-3.723,4.934l-5.853,26.988 c-0.405,1.864,0.607,2.675,2.259,1.814c1.653-0.862,3.32-3.071,3.724-4.936l5.853-26.985c0.405-1.861-0.606-2.676-2.26-1.813 V497.17z M1086.791,488.795c-1.653,0.862-3.318,3.069-3.724,4.935l-5.851,26.987c-0.406,1.861,0.607,2.673,2.26,1.813 c1.651-0.863,3.318-3.071,3.724-4.936l5.852-26.988C1089.457,488.746,1088.443,487.934,1086.791,488.795z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_138_",
    gradientUnits: "userSpaceOnUse",
    x1: 381.8805,
    y1: 664.414,
    x2: 380.9364,
    y2: 665.8449,
    gradientTransform: "matrix(29.342 0 0 -37.133 -10138.6094 25238.9609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00C2FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B78FF"
    }
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_138_)",
    d: "M1027.467,508.922l5.891,38.718l45.309,26.076l-5.881-38.365L1027.467,508.922z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_139_",
    gradientUnits: "userSpaceOnUse",
    x1: 388.6158,
    y1: 665.8408,
    x2: 390.361,
    y2: 665.6885,
    gradientTransform: "matrix(69.633 0 0 -38.519 -26033.416 26146.3164)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A22BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B0F89"
    }
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_139_)",
    d: "M1103.591,472.548l-68.299,36.522l37.564,21.941l68.269-36.955L1103.591,472.548z  M1148.971,494.153l-76.186,41.241l-45.318-26.471l76.188-40.741L1148.971,494.153z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_140_",
    gradientUnits: "userSpaceOnUse",
    x1: 346.9928,
    y1: 650.6054,
    x2: 347.1894,
    y2: 651.7129,
    gradientTransform: "matrix(7.99 0 0 -12.0269 -1683.2081 8420.2207)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#131AA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#090C62"
    }
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_140_)",
    d: "M1085.622,597.256c-1.367-0.819-2.239-2.768-2.239-5.52c0-4.863,2.723-10.392,6.081-12.346 c1.571-0.914,3.001-0.884,4.078-0.099l3.782,2.203l-1.875,4.793c-0.513,4.41-2.997,8.974-5.985,10.713 c-0.082,0.048-0.164,0.096-0.247,0.138l0.57,2.55l-4.167-2.428v-0.005H1085.622z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_141_",
    gradientUnits: "userSpaceOnUse",
    x1: 339.837,
    y1: 649.3095,
    x2: 340.5528,
    y2: 648.812,
    gradientTransform: "matrix(6.969 0 0 -10.8816 -1278.0875 7652.5156)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A22BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B0F89"
    }
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_141_)",
    d: "M1093.535,599.387c3.357-1.956,6.08-7.483,6.08-12.347s-2.723-7.22-6.08-5.265 c-3.356,1.954-6.082,7.482-6.082,12.347C1087.453,598.987,1090.176,601.342,1093.535,599.387L1093.535,599.387z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00BDFA",
    strokeWidth: 0.657,
    d: "M1093.247,595.727c1.961-1.143,3.612-4.49,3.612-7.416 c0-2.725-1.326-3.873-3.036-2.88c-1.962,1.143-3.612,4.492-3.612,7.416C1090.211,595.574,1091.538,596.722,1093.247,595.727z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_142_",
    gradientUnits: "userSpaceOnUse",
    x1: 348.9825,
    y1: 651.2568,
    x2: 349.1792,
    y2: 652.3643,
    gradientTransform: "matrix(7.99 0 0 -12.0269 -1661.8566 8409.6973)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#131AA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#090C62"
    }
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_142_)",
    d: "M1122.872,578.899c-1.365-0.819-2.237-2.768-2.237-5.519c0-4.861,2.721-10.389,6.08-12.345 c1.57-0.914,3.002-0.884,4.078-0.1l3.782,2.204l-1.874,4.794c-0.513,4.409-3,8.974-5.986,10.713 c-0.081,0.047-0.164,0.093-0.247,0.137l0.569,2.55l-4.165-2.429V578.899L1122.872,578.899z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_143_",
    gradientUnits: "userSpaceOnUse",
    x1: 342.1178,
    y1: 650.0292,
    x2: 342.8337,
    y2: 649.5317,
    gradientTransform: "matrix(6.969 0 0 -10.8816 -1256.7399 7641.9922)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A22BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B0F89"
    }
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_143_)",
    d: "M1130.785,581.032c3.356-1.954,6.08-7.482,6.08-12.346c0-4.864-2.724-7.221-6.08-5.268 c-3.357,1.954-6.08,7.482-6.08,12.347C1124.705,580.631,1127.427,582.988,1130.785,581.032L1130.785,581.032z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00BDFA",
    strokeWidth: 0.657,
    d: "M1130.496,577.371c1.963-1.14,3.612-4.488,3.612-7.415 c0-2.724-1.327-3.873-3.035-2.879c-1.961,1.144-3.61,4.493-3.61,7.416c0,2.725,1.324,3.874,3.035,2.878H1130.496z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroHome);
export default __webpack_public_path__ + "static/media/hero-home.dd6a61e005bd318d41e053e1e11f7dd3.svg";
export { ForwardRef as ReactComponent };